/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type __SubscriptionContainer = {
  onCreateMission: OnCreateMissionSubscription;
  onUpdateMission: OnUpdateMissionSubscription;
  onDeleteMission: OnDeleteMissionSubscription;
  onUpdateVisitTemplate: OnUpdateVisitTemplateSubscription;
  subscribeToChannel: SubscribeToChannelSubscription;
  onCreateChatMessage: OnCreateChatMessageSubscription;
  onUpdateChatMessage: OnUpdateChatMessageSubscription;
  onDeleteChatMessage: OnDeleteChatMessageSubscription;
  onCreateSpace: OnCreateSpaceSubscription;
  onUpdateSpace: OnUpdateSpaceSubscription;
  onDeleteSpace: OnDeleteSpaceSubscription;
  onCreateZone: OnCreateZoneSubscription;
  onUpdateZone: OnUpdateZoneSubscription;
  onDeleteZone: OnDeleteZoneSubscription;
  onCreateLayer: OnCreateLayerSubscription;
  onUpdateLayer: OnUpdateLayerSubscription;
  onDeleteLayer: OnDeleteLayerSubscription;
  onCreateNavigation: OnCreateNavigationSubscription;
  onUpdateNavigation: OnUpdateNavigationSubscription;
  onDeleteNavigation: OnDeleteNavigationSubscription;
  onCreatePOI: OnCreatePOISubscription;
  onUpdatePOI: OnUpdatePOISubscription;
  onDeletePOI: OnDeletePOISubscription;
  onCreatePlan: OnCreatePlanSubscription;
  onUpdatePlan: OnUpdatePlanSubscription;
  onDeletePlan: OnDeletePlanSubscription;
  onCreateDomain: OnCreateDomainSubscription;
  onUpdateDomain: OnUpdateDomainSubscription;
  onDeleteDomain: OnDeleteDomainSubscription;
  onCreateComment: OnCreateCommentSubscription;
  onUpdateComment: OnUpdateCommentSubscription;
  onDeleteComment: OnDeleteCommentSubscription;
  onCreateFeature: OnCreateFeatureSubscription;
  onUpdateFeature: OnUpdateFeatureSubscription;
  onDeleteFeature: OnDeleteFeatureSubscription;
  onCreateHashtag: OnCreateHashtagSubscription;
  onUpdateHashtag: OnUpdateHashtagSubscription;
  onDeleteHashtag: OnDeleteHashtagSubscription;
  onCreateProfile: OnCreateProfileSubscription;
  onUpdateProfile: OnUpdateProfileSubscription;
  onDeleteProfile: OnDeleteProfileSubscription;
  onCreateOrganisation: OnCreateOrganisationSubscription;
  onUpdateOrganisation: OnUpdateOrganisationSubscription;
  onDeleteOrganisation: OnDeleteOrganisationSubscription;
  onCreateProperty: OnCreatePropertySubscription;
  onUpdateProperty: OnUpdatePropertySubscription;
  onDeleteProperty: OnDeletePropertySubscription;
  onCreateCapture: OnCreateCaptureSubscription;
  onUpdateCapture: OnUpdateCaptureSubscription;
  onDeleteCapture: OnDeleteCaptureSubscription;
  onCreateNode: OnCreateNodeSubscription;
  onUpdateNode: OnUpdateNodeSubscription;
  onDeleteNode: OnDeleteNodeSubscription;
};

export type Channel = {
  __typename: "Channel";
  name: string;
  data: string;
};

export type CreateChatMessageInput = {
  id?: string | null;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  authorID?: string | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: ZoomChatRecordInput | null;
};

export enum ChatMessageType {
  RAISE_HAND = "RAISE_HAND",
  AUTHORIZE_MICRO = "AUTHORIZE_MICRO",
  ALLOWED_TO_SPEAK = "ALLOWED_TO_SPEAK",
  REFUSE_MICRO = "REFUSE_MICRO",
  REFUSED_TO_SPEAK = "REFUSED_TO_SPEAK",
  FINISHED_SPEAKING = "FINISHED_SPEAKING",
  CANCEL_RAISE_HAND = "CANCEL_RAISE_HAND",
  TECHNICAL_PROBLEMS = "TECHNICAL_PROBLEMS",
  DEFAULT = "DEFAULT"
}

export type ZoomChatRecordInput = {
  id?: string | null;
  message?: string | null;
  sender?: ZoomUserInput | null;
  receiver?: ZoomUserInput | null;
  timestamp?: number | null;
};

export type ZoomUserInput = {
  name?: string | null;
  userId?: number | null;
};

export type ModelChatMessageConditionInput = {
  message?: ModelStringInput | null;
  type?: ModelChatMessageTypeInput | null;
  visitTemplateID?: ModelIDInput | null;
  authorID?: ModelIDInput | null;
  timestamp?: ModelIntInput | null;
  receiver?: ModelStringInput | null;
  toAll?: ModelBooleanInput | null;
  and?: Array<ModelChatMessageConditionInput | null> | null;
  or?: Array<ModelChatMessageConditionInput | null> | null;
  not?: ModelChatMessageConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelChatMessageTypeInput = {
  eq?: ChatMessageType | null;
  ne?: ChatMessageType | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ChatMessage = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: VisitTemplate | null;
  authorID?: string | null;
  author?: Profile | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: ZoomChatRecord | null;
  createdAt: string;
  updatedAt: string;
};

export type VisitTemplate = {
  __typename: "VisitTemplate";
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  organisation?: Organisation | null;
  spaceID?: string | null;
  space?: Space | null;
  zoneID?: string | null;
  zone?: Zone | null;
  userMissions?: ModelMissionConnection | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export enum LevelStatus {
  MINIMUM = "MINIMUM",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  MAXIMUM = "MAXIMUM"
}

export type Organisation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: ModelPropertyConnection | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelPropertyConnection = {
  __typename: "ModelPropertyConnection";
  items: Array<Property | null>;
  nextToken?: string | null;
};

export type Property = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: Organisation | null;
  spaceID: string;
  space?: Space | null;
  zoneID?: string | null;
  zone?: Zone | null;
  createdAt: string;
  updatedAt: string;
};

export enum PropertyType {
  PROPERTY = "PROPERTY",
  VISIT = "VISIT",
  OCCUPANT = "OCCUPANT",
  SHARED = "SHARED"
}

export type Space = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: ModelPropertyConnection | null;
  zones?: ModelZoneConnection | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: Organisation | null;
  attachments?: Array<Comment | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelZoneConnection = {
  __typename: "ModelZoneConnection";
  items: Array<Zone | null>;
  nextToken?: string | null;
};

export type Zone = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: Zone | null;
  spaceID?: string | null;
  space?: Space | null;
  layerID?: string | null;
  layer?: Layer | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: Comment | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type Layer = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: Organisation | null;
  createdAt: string;
  updatedAt: string;
};

export type Comment = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: Mission | null;
  spaceID?: string | null;
  space?: Space | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: Feature | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: ModelPOIConnection | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type Mission = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: Organisation | null;
  organisationID: string;
  organisation?: Organisation | null;
  userID: string;
  user?: Profile | null;
  spaceID?: string | null;
  space?: Space | null;
  zoneID?: string | null;
  zone?: Zone | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: VisitTemplate | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export enum RoleStatus {
  VISITOR = "VISITOR",
  VISITOR_MUSEUM = "VISITOR_MUSEUM",
  GUIDE_MUSEUM = "GUIDE_MUSEUM",
  OCCUPANT = "OCCUPANT",
  SERVICE = "SERVICE",
  MANAGER = "MANAGER",
  OWNER = "OWNER",
  ADMIN = "ADMIN"
}

export enum EmailStatus {
  CREATION_TO_DELIVER = "CREATION_TO_DELIVER",
  UPDATE_TO_DELIVER = "UPDATE_TO_DELIVER",
  CANCELLATION_TO_DELIVER = "CANCELLATION_TO_DELIVER",
  SENT = "SENT",
  SOFT_BOUNCE = "SOFT_BOUNCE",
  HARD_BOUNCE = "HARD_BOUNCE",
  REJECTED = "REJECTED",
  SATISFACTION_TO_DELIVER = "SATISFACTION_TO_DELIVER"
}

export type Profile = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export enum ProfileStatus {
  WAITING_FOR_VALIDATION = "WAITING_FOR_VALIDATION",
  WAITING_FOR_ACTIVATION = "WAITING_FOR_ACTIVATION",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  BLOCKED = "BLOCKED"
}

export enum Locale {
  FR = "FR",
  EN = "EN"
}

export enum CommentType {
  MEASURE = "MEASURE",
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT",
  IMAGE = "IMAGE",
  TEXT = "TEXT",
  AUDIO = "AUDIO",
  URL = "URL",
  YOUTUBE = "YOUTUBE",
  URL_SHOP = "URL_SHOP",
  EMBED = "EMBED"
}

export type Feature = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: Space | null;
  ownerMissionID?: string | null;
  ownerMission?: Mission | null;
  level?: LevelStatus | null;
  comments?: ModelCommentConnection | null;
  index?: number | null;
  domainID?: string | null;
  domain?: Domain | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: ModelPOIConnection | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelCommentConnection = {
  __typename: "ModelCommentConnection";
  items: Array<Comment | null>;
  nextToken?: string | null;
};

export type Domain = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: Organisation | null;
  parentID?: string | null;
  parent?: Domain | null;
  children?: ModelDomainConnection | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelDomainConnection = {
  __typename: "ModelDomainConnection";
  items: Array<Domain | null>;
  nextToken?: string | null;
};

export enum DomainType {
  EQUIPMENT = "EQUIPMENT",
  MISSION = "MISSION",
  TICKET = "TICKET",
  POI = "POI",
  FEATURE = "FEATURE",
  BOOKING = "BOOKING"
}

export enum FeatureType {
  DESK = "DESK",
  INDICATOR_TEMP = "INDICATOR_TEMP",
  INFORMATION = "INFORMATION",
  INDICATOR_CO2 = "INDICATOR_CO2",
  PURCHASE = "PURCHASE"
}

export type ModelPOIConnection = {
  __typename: "ModelPOIConnection";
  items: Array<POI | null>;
  nextToken?: string | null;
};

export type POI = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: Domain | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export enum PoiType {
  EQUIPMENT = "EQUIPMENT",
  INFORMATION = "INFORMATION",
  TICKET = "TICKET",
  MEASURE = "MEASURE",
  DATA = "DATA",
  PEOPLE = "PEOPLE",
  DESK = "DESK"
}

export enum SpaceStatus {
  DPE_TO_VALIDATE = "DPE_TO_VALIDATE",
  DPE_VALIDATED = "DPE_VALIDATED",
  DPE_FETCH = "DPE_FETCH"
}

export type ModelMissionConnection = {
  __typename: "ModelMissionConnection";
  items: Array<Mission | null>;
  nextToken?: string | null;
};

export type ZoomChatRecord = {
  __typename: "ZoomChatRecord";
  id?: string | null;
  message?: string | null;
  sender?: ZoomUser | null;
  receiver?: ZoomUser | null;
  timestamp?: number | null;
};

export type ZoomUser = {
  __typename: "ZoomUser";
  name?: string | null;
  userId?: number | null;
};

export type UpdateChatMessageInput = {
  id: string;
  message?: string | null;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  authorID?: string | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: ZoomChatRecordInput | null;
};

export type DeleteChatMessageInput = {
  id: string;
};

export type CreateSpaceInput = {
  id?: string | null;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
};

export type ModelSpaceConditionInput = {
  name?: ModelStringInput | null;
  addresses?: ModelStringInput | null;
  annexes?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  latitude?: ModelFloatInput | null;
  longitude?: ModelFloatInput | null;
  metadata?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  deletedAt?: ModelIntInput | null;
  constructionYear?: ModelStringInput | null;
  classEnergyConsumption?: ModelStringInput | null;
  classGes?: ModelStringInput | null;
  status?: ModelSpaceStatusInput | null;
  guestLink?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  and?: Array<ModelSpaceConditionInput | null> | null;
  or?: Array<ModelSpaceConditionInput | null> | null;
  not?: ModelSpaceConditionInput | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelLevelStatusInput = {
  eq?: LevelStatus | null;
  ne?: LevelStatus | null;
};

export type ModelSpaceStatusInput = {
  eq?: SpaceStatus | null;
  ne?: SpaceStatus | null;
};

export type UpdateSpaceInput = {
  id: string;
  name?: string | null;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
};

export type DeleteSpaceInput = {
  id: string;
};

export type CreateZoneInput = {
  id?: string | null;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  spaceID?: string | null;
  layerID?: string | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  startSweepID?: string | null;
};

export type ModelZoneConditionInput = {
  name?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  parentID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  layerID?: ModelIDInput | null;
  isMuseumVisitZone?: ModelBooleanInput | null;
  sweepIDs?: ModelStringInput | null;
  nodeIDs?: ModelStringInput | null;
  isMultipleFloorZone?: ModelBooleanInput | null;
  audioID?: ModelIDInput | null;
  startSweepID?: ModelStringInput | null;
  and?: Array<ModelZoneConditionInput | null> | null;
  or?: Array<ModelZoneConditionInput | null> | null;
  not?: ModelZoneConditionInput | null;
};

export type UpdateZoneInput = {
  id: string;
  name?: string | null;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  spaceID?: string | null;
  layerID?: string | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  startSweepID?: string | null;
};

export type DeleteZoneInput = {
  id: string;
};

export type CreateLayerInput = {
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
};

export type ModelLayerConditionInput = {
  name?: ModelStringInput | null;
  slug?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  and?: Array<ModelLayerConditionInput | null> | null;
  or?: Array<ModelLayerConditionInput | null> | null;
  not?: ModelLayerConditionInput | null;
};

export type UpdateLayerInput = {
  id: string;
  name?: string | null;
  slug?: string | null;
  organisationID?: string | null;
};

export type DeleteLayerInput = {
  id: string;
};

export type CreateNavigationInput = {
  id?: string | null;
  matterportSweepID?: string | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
};

export type ModelNavigationConditionInput = {
  matterportSweepID?: ModelStringInput | null;
  position?: ModelStringInput | null;
  rotation?: ModelStringInput | null;
  radius?: ModelIntInput | null;
  url?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  nodeID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  positionOnPlan?: ModelStringInput | null;
  and?: Array<ModelNavigationConditionInput | null> | null;
  or?: Array<ModelNavigationConditionInput | null> | null;
  not?: ModelNavigationConditionInput | null;
};

export type Navigation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<Navigation | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: Node | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type Node = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: Capture | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export enum NodeQuality {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH"
}

export type Capture = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: ModelNodeConnection | null;
  createdAt: string;
  updatedAt: string;
};

export enum CaptureViewer {
  CUPIX = "CUPIX",
  MATTERPORT = "MATTERPORT",
  SMARTERPLAN_V1 = "SMARTERPLAN_V1"
}

export type ModelNodeConnection = {
  __typename: "ModelNodeConnection";
  items: Array<Node | null>;
  nextToken?: string | null;
};

export enum InventoryStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  TO_RUN = "TO_RUN",
  TO_RUN_ONE_IMAGE = "TO_RUN_ONE_IMAGE",
  ERROR_FILE_OBJ_NOT_EXIST = "ERROR_FILE_OBJ_NOT_EXIST",
  ERROR_FILE_JSON_NOT_EXIST = "ERROR_FILE_JSON_NOT_EXIST",
  ERROR_FILE_MODEL_NOT_EXIST = "ERROR_FILE_MODEL_NOT_EXIST"
}

export type UpdateNavigationInput = {
  id: string;
  matterportSweepID?: string | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
};

export type DeleteNavigationInput = {
  id: string;
};

export type CreatePOIInput = {
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
};

export type ModelPOIConditionInput = {
  coordinate?: ModelStringInput | null;
  specific?: ModelBooleanInput | null;
  private?: ModelBooleanInput | null;
  global?: ModelBooleanInput | null;
  type?: ModelPoiTypeInput | null;
  elementID?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  category?: ModelStringInput | null;
  domainID?: ModelIDInput | null;
  metadata?: ModelStringInput | null;
  tagIcon?: ModelStringInput | null;
  tagDescription?: ModelStringInput | null;
  tagImageID?: ModelIDInput | null;
  matterportSweepID?: ModelStringInput | null;
  and?: Array<ModelPOIConditionInput | null> | null;
  or?: Array<ModelPOIConditionInput | null> | null;
  not?: ModelPOIConditionInput | null;
};

export type ModelPoiTypeInput = {
  eq?: PoiType | null;
  ne?: PoiType | null;
};

export type ModelRoleStatusInput = {
  eq?: RoleStatus | null;
  ne?: RoleStatus | null;
};

export type UpdatePOIInput = {
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
};

export type DeletePOIInput = {
  id: string;
};

export type CreatePlanInput = {
  id?: string | null;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
};

export type ModelPlanConditionInput = {
  name?: ModelStringInput | null;
  annexe?: ModelStringInput | null;
  calibration?: ModelStringInput | null;
  zoneID?: ModelIDInput | null;
  isCurrentForZone?: ModelBooleanInput | null;
  spaceID?: ModelIDInput | null;
  isModified?: ModelBooleanInput | null;
  isImportedMatterport?: ModelBooleanInput | null;
  and?: Array<ModelPlanConditionInput | null> | null;
  or?: Array<ModelPlanConditionInput | null> | null;
  not?: ModelPlanConditionInput | null;
};

export type Plan = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: Zone | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: Space | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePlanInput = {
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
};

export type DeletePlanInput = {
  id: string;
};

export type CreateDomainInput = {
  id?: string | null;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  parentID?: string | null;
  type?: DomainType | null;
};

export type ModelDomainConditionInput = {
  name?: ModelStringInput | null;
  slug?: ModelStringInput | null;
  abbreviation?: ModelStringInput | null;
  description?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  parentID?: ModelIDInput | null;
  type?: ModelDomainTypeInput | null;
  and?: Array<ModelDomainConditionInput | null> | null;
  or?: Array<ModelDomainConditionInput | null> | null;
  not?: ModelDomainConditionInput | null;
};

export type ModelDomainTypeInput = {
  eq?: DomainType | null;
  ne?: DomainType | null;
};

export type UpdateDomainInput = {
  id: string;
  name?: string | null;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  parentID?: string | null;
  type?: DomainType | null;
};

export type DeleteDomainInput = {
  id: string;
};

export type CreateCommentInput = {
  id?: string | null;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  spaceID?: string | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
};

export type ModelCommentConditionInput = {
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  annexe?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  ownerID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  type?: ModelCommentTypeInput | null;
  dimensions?: ModelFloatInput | null;
  featureID?: ModelIDInput | null;
  isCoverImage?: ModelBooleanInput | null;
  index?: ModelIntInput | null;
  shownInTag?: ModelBooleanInput | null;
  externalLink?: ModelStringInput | null;
  and?: Array<ModelCommentConditionInput | null> | null;
  or?: Array<ModelCommentConditionInput | null> | null;
  not?: ModelCommentConditionInput | null;
};

export type ModelCommentTypeInput = {
  eq?: CommentType | null;
  ne?: CommentType | null;
};

export type UpdateCommentInput = {
  id: string;
  title?: string | null;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  spaceID?: string | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
};

export type DeleteCommentInput = {
  id: string;
};

export type CreateFeatureInput = {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  ownerMissionID?: string | null;
  level?: LevelStatus | null;
  index?: number | null;
  domainID?: string | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
};

export type ModelFeatureConditionInput = {
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  shortDescription?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  ownerMissionID?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  index?: ModelIntInput | null;
  domainID?: ModelIDInput | null;
  type?: ModelFeatureTypeInput | null;
  archivedForMissionID?: ModelStringInput | null;
  stripeProductID?: ModelStringInput | null;
  stripePriceID?: ModelStringInput | null;
  bookingPriceMetadata?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  locale?: ModelLocaleInput | null;
  and?: Array<ModelFeatureConditionInput | null> | null;
  or?: Array<ModelFeatureConditionInput | null> | null;
  not?: ModelFeatureConditionInput | null;
};

export type ModelFeatureTypeInput = {
  eq?: FeatureType | null;
  ne?: FeatureType | null;
};

export type ModelLocaleInput = {
  eq?: Locale | null;
  ne?: Locale | null;
};

export type UpdateFeatureInput = {
  id: string;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID?: string | null;
  ownerMissionID?: string | null;
  level?: LevelStatus | null;
  index?: number | null;
  domainID?: string | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
};

export type DeleteFeatureInput = {
  id: string;
};

export type CreateHashtagInput = {
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  spaceID?: string | null;
};

export type ModelHashtagConditionInput = {
  name?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelHashtagConditionInput | null> | null;
  or?: Array<ModelHashtagConditionInput | null> | null;
  not?: ModelHashtagConditionInput | null;
};

export type Hashtag = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: Organisation | null;
  spaceID?: string | null;
  space?: Space | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateHashtagInput = {
  id: string;
  name?: string | null;
  organisationID?: string | null;
  spaceID?: string | null;
};

export type DeleteHashtagInput = {
  id: string;
};

export type CreateProfileInput = {
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
};

export type ModelProfileConditionInput = {
  userID?: ModelStringInput | null;
  avatar?: ModelStringInput | null;
  token?: ModelStringInput | null;
  tokenExpiredAt?: ModelIntInput | null;
  status?: ModelProfileStatusInput | null;
  metadata?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  lastConnectedAt?: ModelIntInput | null;
  pseudo?: ModelStringInput | null;
  and?: Array<ModelProfileConditionInput | null> | null;
  or?: Array<ModelProfileConditionInput | null> | null;
  not?: ModelProfileConditionInput | null;
};

export type ModelProfileStatusInput = {
  eq?: ProfileStatus | null;
  ne?: ProfileStatus | null;
};

export type UpdateProfileInput = {
  id: string;
  userID?: string | null;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
};

export type DeleteProfileInput = {
  id: string;
};

export type CreateOrganisationInput = {
  id?: string | null;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
};

export type ModelOrganisationConditionInput = {
  name?: ModelStringInput | null;
  siret?: ModelStringInput | null;
  address?: ModelStringInput | null;
  city?: ModelStringInput | null;
  postal?: ModelIntInput | null;
  logoUrl?: ModelStringInput | null;
  originDate?: ModelIntInput | null;
  deletedAt?: ModelIntInput | null;
  shareToken?: ModelStringInput | null;
  tokenExpiresAt?: ModelIntInput | null;
  connectedAccountStripeID?: ModelStringInput | null;
  stripeOnBoardingCompleted?: ModelBooleanInput | null;
  stripeToken?: ModelStringInput | null;
  stripeChargesEnabled?: ModelBooleanInput | null;
  contactDetails?: ModelStringInput | null;
  and?: Array<ModelOrganisationConditionInput | null> | null;
  or?: Array<ModelOrganisationConditionInput | null> | null;
  not?: ModelOrganisationConditionInput | null;
};

export type UpdateOrganisationInput = {
  id: string;
  name?: string | null;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
};

export type DeleteOrganisationInput = {
  id: string;
};

export type CreatePropertyInput = {
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  spaceID: string;
  zoneID?: string | null;
};

export type ModelPropertyConditionInput = {
  type?: ModelPropertyTypeInput | null;
  deletedAt?: ModelIntInput | null;
  organisationID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  and?: Array<ModelPropertyConditionInput | null> | null;
  or?: Array<ModelPropertyConditionInput | null> | null;
  not?: ModelPropertyConditionInput | null;
};

export type ModelPropertyTypeInput = {
  eq?: PropertyType | null;
  ne?: PropertyType | null;
};

export type UpdatePropertyInput = {
  id: string;
  type?: PropertyType | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  spaceID?: string | null;
  zoneID?: string | null;
};

export type DeletePropertyInput = {
  id: string;
};

export type CreateMissionInput = {
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  organisationID: string;
  userID: string;
  spaceID?: string | null;
  zoneID?: string | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
};

export type ModelMissionConditionInput = {
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  emailStatus?: ModelEmailStatusInput | null;
  description?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  groups?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  startDateTime?: ModelStringInput | null;
  endDateTime?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  orderedOrganisationID?: ModelIDInput | null;
  organisationID?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  domains?: ModelStringInput | null;
  templateMissionID?: ModelIDInput | null;
  locale?: ModelLocaleInput | null;
  isInWaitingRoom?: ModelBooleanInput | null;
  blockedInChat?: ModelBooleanInput | null;
  connectedToLiveAt?: ModelStringInput | null;
  disconnectedFromLiveAt?: ModelStringInput | null;
  and?: Array<ModelMissionConditionInput | null> | null;
  or?: Array<ModelMissionConditionInput | null> | null;
  not?: ModelMissionConditionInput | null;
};

export type ModelEmailStatusInput = {
  eq?: EmailStatus | null;
  ne?: EmailStatus | null;
};

export type UpdateMissionInput = {
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  organisationID?: string | null;
  userID?: string | null;
  spaceID?: string | null;
  zoneID?: string | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
};

export type DeleteMissionInput = {
  id: string;
};

export type CreateVisitTemplateInput = {
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  spaceID?: string | null;
  zoneID?: string | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
};

export type ModelVisitTemplateConditionInput = {
  title?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  description?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  startDateTime?: ModelStringInput | null;
  endDateTime?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  locale?: ModelLocaleInput | null;
  realStartedAt?: ModelIntInput | null;
  realEndedAt?: ModelIntInput | null;
  and?: Array<ModelVisitTemplateConditionInput | null> | null;
  or?: Array<ModelVisitTemplateConditionInput | null> | null;
  not?: ModelVisitTemplateConditionInput | null;
};

export type UpdateVisitTemplateInput = {
  id: string;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID?: string | null;
  spaceID?: string | null;
  zoneID?: string | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
};

export type DeleteVisitTemplateInput = {
  id: string;
};

export type CreateCaptureInput = {
  id?: string | null;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
};

export type ModelCaptureConditionInput = {
  clientRef?: ModelStringInput | null;
  originCoordinate?: ModelStringInput | null;
  originAngle?: ModelStringInput | null;
  originZoom?: ModelStringInput | null;
  takenAt?: ModelIntInput | null;
  viewer?: ModelCaptureViewerInput | null;
  publishedAt?: ModelIntInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelCaptureConditionInput | null> | null;
  or?: Array<ModelCaptureConditionInput | null> | null;
  not?: ModelCaptureConditionInput | null;
};

export type ModelCaptureViewerInput = {
  eq?: CaptureViewer | null;
  ne?: CaptureViewer | null;
};

export type UpdateCaptureInput = {
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
};

export type DeleteCaptureInput = {
  id: string;
};

export type CreateNodeInput = {
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
};

export type ModelNodeConditionInput = {
  model3D?: ModelStringInput | null;
  coordinate?: ModelStringInput | null;
  size?: ModelStringInput | null;
  scale?: ModelStringInput | null;
  version?: ModelIntInput | null;
  active?: ModelIntInput | null;
  order?: ModelIntInput | null;
  quality?: ModelNodeQualityInput | null;
  metadata?: ModelStringInput | null;
  captureID?: ModelIDInput | null;
  inventoryStatus?: ModelInventoryStatusInput | null;
  navigationForInventory?: ModelStringInput | null;
  and?: Array<ModelNodeConditionInput | null> | null;
  or?: Array<ModelNodeConditionInput | null> | null;
  not?: ModelNodeConditionInput | null;
};

export type ModelNodeQualityInput = {
  eq?: NodeQuality | null;
  ne?: NodeQuality | null;
};

export type ModelInventoryStatusInput = {
  eq?: InventoryStatus | null;
  ne?: InventoryStatus | null;
};

export type UpdateNodeInput = {
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
};

export type DeleteNodeInput = {
  id: string;
};

export type ModelChatMessageFilterInput = {
  id?: ModelIDInput | null;
  message?: ModelStringInput | null;
  type?: ModelChatMessageTypeInput | null;
  visitTemplateID?: ModelIDInput | null;
  authorID?: ModelIDInput | null;
  timestamp?: ModelIntInput | null;
  receiver?: ModelStringInput | null;
  toAll?: ModelBooleanInput | null;
  and?: Array<ModelChatMessageFilterInput | null> | null;
  or?: Array<ModelChatMessageFilterInput | null> | null;
  not?: ModelChatMessageFilterInput | null;
};

export type ModelChatMessageConnection = {
  __typename: "ModelChatMessageConnection";
  items: Array<ChatMessage | null>;
  nextToken?: string | null;
};

export type ModelIntKeyConditionInput = {
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type ModelSpaceFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  addresses?: ModelStringInput | null;
  annexes?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  latitude?: ModelFloatInput | null;
  longitude?: ModelFloatInput | null;
  metadata?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  deletedAt?: ModelIntInput | null;
  constructionYear?: ModelStringInput | null;
  classEnergyConsumption?: ModelStringInput | null;
  classGes?: ModelStringInput | null;
  status?: ModelSpaceStatusInput | null;
  guestLink?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  and?: Array<ModelSpaceFilterInput | null> | null;
  or?: Array<ModelSpaceFilterInput | null> | null;
  not?: ModelSpaceFilterInput | null;
};

export type ModelSpaceConnection = {
  __typename: "ModelSpaceConnection";
  items: Array<Space | null>;
  nextToken?: string | null;
};

export type ModelZoneFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  parentID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  layerID?: ModelIDInput | null;
  isMuseumVisitZone?: ModelBooleanInput | null;
  sweepIDs?: ModelStringInput | null;
  nodeIDs?: ModelStringInput | null;
  isMultipleFloorZone?: ModelBooleanInput | null;
  audioID?: ModelIDInput | null;
  startSweepID?: ModelStringInput | null;
  and?: Array<ModelZoneFilterInput | null> | null;
  or?: Array<ModelZoneFilterInput | null> | null;
  not?: ModelZoneFilterInput | null;
};

export type ModelLayerFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  slug?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  and?: Array<ModelLayerFilterInput | null> | null;
  or?: Array<ModelLayerFilterInput | null> | null;
  not?: ModelLayerFilterInput | null;
};

export type ModelLayerConnection = {
  __typename: "ModelLayerConnection";
  items: Array<Layer | null>;
  nextToken?: string | null;
};

export type ModelNavigationFilterInput = {
  id?: ModelIDInput | null;
  matterportSweepID?: ModelStringInput | null;
  position?: ModelStringInput | null;
  rotation?: ModelStringInput | null;
  radius?: ModelIntInput | null;
  url?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  nodeID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  positionOnPlan?: ModelStringInput | null;
  and?: Array<ModelNavigationFilterInput | null> | null;
  or?: Array<ModelNavigationFilterInput | null> | null;
  not?: ModelNavigationFilterInput | null;
};

export type ModelNavigationConnection = {
  __typename: "ModelNavigationConnection";
  items: Array<Navigation | null>;
  nextToken?: string | null;
};

export type ModelIDKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelPOIFilterInput = {
  id?: ModelIDInput | null;
  coordinate?: ModelStringInput | null;
  specific?: ModelBooleanInput | null;
  private?: ModelBooleanInput | null;
  global?: ModelBooleanInput | null;
  type?: ModelPoiTypeInput | null;
  elementID?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  category?: ModelStringInput | null;
  domainID?: ModelIDInput | null;
  metadata?: ModelStringInput | null;
  tagIcon?: ModelStringInput | null;
  tagDescription?: ModelStringInput | null;
  tagImageID?: ModelIDInput | null;
  matterportSweepID?: ModelStringInput | null;
  and?: Array<ModelPOIFilterInput | null> | null;
  or?: Array<ModelPOIFilterInput | null> | null;
  not?: ModelPOIFilterInput | null;
};

export type ModelPlanFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  annexe?: ModelStringInput | null;
  calibration?: ModelStringInput | null;
  zoneID?: ModelIDInput | null;
  isCurrentForZone?: ModelBooleanInput | null;
  spaceID?: ModelIDInput | null;
  isModified?: ModelBooleanInput | null;
  isImportedMatterport?: ModelBooleanInput | null;
  and?: Array<ModelPlanFilterInput | null> | null;
  or?: Array<ModelPlanFilterInput | null> | null;
  not?: ModelPlanFilterInput | null;
};

export type ModelPlanConnection = {
  __typename: "ModelPlanConnection";
  items: Array<Plan | null>;
  nextToken?: string | null;
};

export type ModelDomainFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  slug?: ModelStringInput | null;
  abbreviation?: ModelStringInput | null;
  description?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  parentID?: ModelIDInput | null;
  type?: ModelDomainTypeInput | null;
  and?: Array<ModelDomainFilterInput | null> | null;
  or?: Array<ModelDomainFilterInput | null> | null;
  not?: ModelDomainFilterInput | null;
};

export type ModelCommentFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  annexe?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  ownerID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  type?: ModelCommentTypeInput | null;
  dimensions?: ModelFloatInput | null;
  featureID?: ModelIDInput | null;
  isCoverImage?: ModelBooleanInput | null;
  index?: ModelIntInput | null;
  shownInTag?: ModelBooleanInput | null;
  externalLink?: ModelStringInput | null;
  and?: Array<ModelCommentFilterInput | null> | null;
  or?: Array<ModelCommentFilterInput | null> | null;
  not?: ModelCommentFilterInput | null;
};

export type ModelFeatureFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  shortDescription?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  ownerMissionID?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  index?: ModelIntInput | null;
  domainID?: ModelIDInput | null;
  type?: ModelFeatureTypeInput | null;
  archivedForMissionID?: ModelStringInput | null;
  stripeProductID?: ModelStringInput | null;
  stripePriceID?: ModelStringInput | null;
  bookingPriceMetadata?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  locale?: ModelLocaleInput | null;
  and?: Array<ModelFeatureFilterInput | null> | null;
  or?: Array<ModelFeatureFilterInput | null> | null;
  not?: ModelFeatureFilterInput | null;
};

export type ModelFeatureConnection = {
  __typename: "ModelFeatureConnection";
  items: Array<Feature | null>;
  nextToken?: string | null;
};

export type ModelHashtagFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelHashtagFilterInput | null> | null;
  or?: Array<ModelHashtagFilterInput | null> | null;
  not?: ModelHashtagFilterInput | null;
};

export type ModelHashtagConnection = {
  __typename: "ModelHashtagConnection";
  items: Array<Hashtag | null>;
  nextToken?: string | null;
};

export type ModelProfileFilterInput = {
  id?: ModelIDInput | null;
  userID?: ModelStringInput | null;
  avatar?: ModelStringInput | null;
  token?: ModelStringInput | null;
  tokenExpiredAt?: ModelIntInput | null;
  status?: ModelProfileStatusInput | null;
  metadata?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  lastConnectedAt?: ModelIntInput | null;
  pseudo?: ModelStringInput | null;
  and?: Array<ModelProfileFilterInput | null> | null;
  or?: Array<ModelProfileFilterInput | null> | null;
  not?: ModelProfileFilterInput | null;
};

export type ModelProfileConnection = {
  __typename: "ModelProfileConnection";
  items: Array<Profile | null>;
  nextToken?: string | null;
};

export type ModelOrganisationFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  siret?: ModelStringInput | null;
  address?: ModelStringInput | null;
  city?: ModelStringInput | null;
  postal?: ModelIntInput | null;
  logoUrl?: ModelStringInput | null;
  originDate?: ModelIntInput | null;
  deletedAt?: ModelIntInput | null;
  shareToken?: ModelStringInput | null;
  tokenExpiresAt?: ModelIntInput | null;
  connectedAccountStripeID?: ModelStringInput | null;
  stripeOnBoardingCompleted?: ModelBooleanInput | null;
  stripeToken?: ModelStringInput | null;
  stripeChargesEnabled?: ModelBooleanInput | null;
  contactDetails?: ModelStringInput | null;
  and?: Array<ModelOrganisationFilterInput | null> | null;
  or?: Array<ModelOrganisationFilterInput | null> | null;
  not?: ModelOrganisationFilterInput | null;
};

export type ModelOrganisationConnection = {
  __typename: "ModelOrganisationConnection";
  items: Array<Organisation | null>;
  nextToken?: string | null;
};

export type ModelPropertyFilterInput = {
  id?: ModelIDInput | null;
  type?: ModelPropertyTypeInput | null;
  deletedAt?: ModelIntInput | null;
  organisationID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  and?: Array<ModelPropertyFilterInput | null> | null;
  or?: Array<ModelPropertyFilterInput | null> | null;
  not?: ModelPropertyFilterInput | null;
};

export type ModelMissionFilterInput = {
  id?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  emailStatus?: ModelEmailStatusInput | null;
  description?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  groups?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  startDateTime?: ModelStringInput | null;
  endDateTime?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  orderedOrganisationID?: ModelIDInput | null;
  organisationID?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  domains?: ModelStringInput | null;
  templateMissionID?: ModelIDInput | null;
  locale?: ModelLocaleInput | null;
  isInWaitingRoom?: ModelBooleanInput | null;
  blockedInChat?: ModelBooleanInput | null;
  connectedToLiveAt?: ModelStringInput | null;
  disconnectedFromLiveAt?: ModelStringInput | null;
  and?: Array<ModelMissionFilterInput | null> | null;
  or?: Array<ModelMissionFilterInput | null> | null;
  not?: ModelMissionFilterInput | null;
};

export type ModelStringKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelVisitTemplateFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  description?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  startDateTime?: ModelStringInput | null;
  endDateTime?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  locale?: ModelLocaleInput | null;
  realStartedAt?: ModelIntInput | null;
  realEndedAt?: ModelIntInput | null;
  and?: Array<ModelVisitTemplateFilterInput | null> | null;
  or?: Array<ModelVisitTemplateFilterInput | null> | null;
  not?: ModelVisitTemplateFilterInput | null;
};

export type ModelVisitTemplateConnection = {
  __typename: "ModelVisitTemplateConnection";
  items: Array<VisitTemplate | null>;
  nextToken?: string | null;
};

export type ModelCaptureFilterInput = {
  id?: ModelIDInput | null;
  clientRef?: ModelStringInput | null;
  originCoordinate?: ModelStringInput | null;
  originAngle?: ModelStringInput | null;
  originZoom?: ModelStringInput | null;
  takenAt?: ModelIntInput | null;
  viewer?: ModelCaptureViewerInput | null;
  publishedAt?: ModelIntInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelCaptureFilterInput | null> | null;
  or?: Array<ModelCaptureFilterInput | null> | null;
  not?: ModelCaptureFilterInput | null;
};

export type ModelCaptureConnection = {
  __typename: "ModelCaptureConnection";
  items: Array<Capture | null>;
  nextToken?: string | null;
};

export type ModelNodeFilterInput = {
  id?: ModelIDInput | null;
  model3D?: ModelStringInput | null;
  coordinate?: ModelStringInput | null;
  size?: ModelStringInput | null;
  scale?: ModelStringInput | null;
  version?: ModelIntInput | null;
  active?: ModelIntInput | null;
  order?: ModelIntInput | null;
  quality?: ModelNodeQualityInput | null;
  metadata?: ModelStringInput | null;
  captureID?: ModelIDInput | null;
  inventoryStatus?: ModelInventoryStatusInput | null;
  navigationForInventory?: ModelStringInput | null;
  and?: Array<ModelNodeFilterInput | null> | null;
  or?: Array<ModelNodeFilterInput | null> | null;
  not?: ModelNodeFilterInput | null;
};

export type ModelSubscriptionChatMessageFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  message?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  visitTemplateID?: ModelSubscriptionIDInput | null;
  authorID?: ModelSubscriptionIDInput | null;
  timestamp?: ModelSubscriptionIntInput | null;
  receiver?: ModelSubscriptionStringInput | null;
  toAll?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionChatMessageFilterInput | null> | null;
  or?: Array<ModelSubscriptionChatMessageFilterInput | null> | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionSpaceFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  addresses?: ModelSubscriptionStringInput | null;
  annexes?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  latitude?: ModelSubscriptionFloatInput | null;
  longitude?: ModelSubscriptionFloatInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  level?: ModelSubscriptionStringInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  constructionYear?: ModelSubscriptionStringInput | null;
  classEnergyConsumption?: ModelSubscriptionStringInput | null;
  classGes?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  guestLink?: ModelSubscriptionStringInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionSpaceFilterInput | null> | null;
  or?: Array<ModelSubscriptionSpaceFilterInput | null> | null;
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionZoneFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  surface?: ModelSubscriptionIntInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  parentID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  layerID?: ModelSubscriptionIDInput | null;
  isMuseumVisitZone?: ModelSubscriptionBooleanInput | null;
  sweepIDs?: ModelSubscriptionStringInput | null;
  nodeIDs?: ModelSubscriptionStringInput | null;
  isMultipleFloorZone?: ModelSubscriptionBooleanInput | null;
  audioID?: ModelSubscriptionIDInput | null;
  startSweepID?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionZoneFilterInput | null> | null;
  or?: Array<ModelSubscriptionZoneFilterInput | null> | null;
};

export type ModelSubscriptionLayerFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  slug?: ModelSubscriptionStringInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionLayerFilterInput | null> | null;
  or?: Array<ModelSubscriptionLayerFilterInput | null> | null;
};

export type ModelSubscriptionNavigationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  matterportSweepID?: ModelSubscriptionStringInput | null;
  position?: ModelSubscriptionStringInput | null;
  rotation?: ModelSubscriptionStringInput | null;
  radius?: ModelSubscriptionIntInput | null;
  url?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  level?: ModelSubscriptionStringInput | null;
  nodeID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  positionOnPlan?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionNavigationFilterInput | null> | null;
  or?: Array<ModelSubscriptionNavigationFilterInput | null> | null;
};

export type ModelSubscriptionPOIFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  coordinate?: ModelSubscriptionStringInput | null;
  specific?: ModelSubscriptionBooleanInput | null;
  private?: ModelSubscriptionBooleanInput | null;
  global?: ModelSubscriptionBooleanInput | null;
  type?: ModelSubscriptionStringInput | null;
  elementID?: ModelSubscriptionIDInput | null;
  level?: ModelSubscriptionStringInput | null;
  role?: ModelSubscriptionStringInput | null;
  category?: ModelSubscriptionStringInput | null;
  domainID?: ModelSubscriptionIDInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  tagIcon?: ModelSubscriptionStringInput | null;
  tagDescription?: ModelSubscriptionStringInput | null;
  tagImageID?: ModelSubscriptionIDInput | null;
  matterportSweepID?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionPOIFilterInput | null> | null;
  or?: Array<ModelSubscriptionPOIFilterInput | null> | null;
};

export type ModelSubscriptionPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  annexe?: ModelSubscriptionStringInput | null;
  calibration?: ModelSubscriptionStringInput | null;
  zoneID?: ModelSubscriptionIDInput | null;
  isCurrentForZone?: ModelSubscriptionBooleanInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  isModified?: ModelSubscriptionBooleanInput | null;
  isImportedMatterport?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionPlanFilterInput | null> | null;
  or?: Array<ModelSubscriptionPlanFilterInput | null> | null;
};

export type ModelSubscriptionDomainFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  slug?: ModelSubscriptionStringInput | null;
  abbreviation?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  parentID?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionDomainFilterInput | null> | null;
  or?: Array<ModelSubscriptionDomainFilterInput | null> | null;
};

export type ModelSubscriptionCommentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  annexe?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  ownerID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  dimensions?: ModelSubscriptionFloatInput | null;
  featureID?: ModelSubscriptionIDInput | null;
  isCoverImage?: ModelSubscriptionBooleanInput | null;
  index?: ModelSubscriptionIntInput | null;
  shownInTag?: ModelSubscriptionBooleanInput | null;
  externalLink?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCommentFilterInput | null> | null;
  or?: Array<ModelSubscriptionCommentFilterInput | null> | null;
};

export type ModelSubscriptionFeatureFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  shortDescription?: ModelSubscriptionStringInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  ownerMissionID?: ModelSubscriptionIDInput | null;
  level?: ModelSubscriptionStringInput | null;
  index?: ModelSubscriptionIntInput | null;
  domainID?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  archivedForMissionID?: ModelSubscriptionStringInput | null;
  stripeProductID?: ModelSubscriptionStringInput | null;
  stripePriceID?: ModelSubscriptionStringInput | null;
  bookingPriceMetadata?: ModelSubscriptionStringInput | null;
  hashtags?: ModelSubscriptionStringInput | null;
  locale?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionFeatureFilterInput | null> | null;
  or?: Array<ModelSubscriptionFeatureFilterInput | null> | null;
};

export type ModelSubscriptionHashtagFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionHashtagFilterInput | null> | null;
  or?: Array<ModelSubscriptionHashtagFilterInput | null> | null;
};

export type ModelSubscriptionProfileFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  userID?: ModelSubscriptionStringInput | null;
  avatar?: ModelSubscriptionStringInput | null;
  token?: ModelSubscriptionStringInput | null;
  tokenExpiredAt?: ModelSubscriptionIntInput | null;
  status?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  lastConnectedAt?: ModelSubscriptionIntInput | null;
  pseudo?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionProfileFilterInput | null> | null;
  or?: Array<ModelSubscriptionProfileFilterInput | null> | null;
};

export type ModelSubscriptionOrganisationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  siret?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  city?: ModelSubscriptionStringInput | null;
  postal?: ModelSubscriptionIntInput | null;
  logoUrl?: ModelSubscriptionStringInput | null;
  originDate?: ModelSubscriptionIntInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  shareToken?: ModelSubscriptionStringInput | null;
  tokenExpiresAt?: ModelSubscriptionIntInput | null;
  connectedAccountStripeID?: ModelSubscriptionStringInput | null;
  stripeOnBoardingCompleted?: ModelSubscriptionBooleanInput | null;
  stripeToken?: ModelSubscriptionStringInput | null;
  stripeChargesEnabled?: ModelSubscriptionBooleanInput | null;
  contactDetails?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionOrganisationFilterInput | null> | null;
  or?: Array<ModelSubscriptionOrganisationFilterInput | null> | null;
};

export type ModelSubscriptionPropertyFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  zoneID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionPropertyFilterInput | null> | null;
  or?: Array<ModelSubscriptionPropertyFilterInput | null> | null;
};

export type ModelSubscriptionCaptureFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  clientRef?: ModelSubscriptionStringInput | null;
  originCoordinate?: ModelSubscriptionStringInput | null;
  originAngle?: ModelSubscriptionStringInput | null;
  originZoom?: ModelSubscriptionStringInput | null;
  takenAt?: ModelSubscriptionIntInput | null;
  viewer?: ModelSubscriptionStringInput | null;
  publishedAt?: ModelSubscriptionIntInput | null;
  surface?: ModelSubscriptionIntInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionCaptureFilterInput | null> | null;
  or?: Array<ModelSubscriptionCaptureFilterInput | null> | null;
};

export type ModelSubscriptionNodeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  model3D?: ModelSubscriptionStringInput | null;
  coordinate?: ModelSubscriptionStringInput | null;
  size?: ModelSubscriptionStringInput | null;
  scale?: ModelSubscriptionStringInput | null;
  version?: ModelSubscriptionIntInput | null;
  active?: ModelSubscriptionIntInput | null;
  order?: ModelSubscriptionIntInput | null;
  quality?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  captureID?: ModelSubscriptionIDInput | null;
  inventoryStatus?: ModelSubscriptionStringInput | null;
  navigationForInventory?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionNodeFilterInput | null> | null;
  or?: Array<ModelSubscriptionNodeFilterInput | null> | null;
};

export type PublishToChannelMutation = {
  __typename: "Channel";
  name: string;
  data: string;
};

export type CreateChatMessageMutation = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateChatMessageMutation = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteChatMessageMutation = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateSpaceMutation = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSpaceMutation = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteSpaceMutation = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateZoneMutation = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateZoneMutation = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteZoneMutation = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateLayerMutation = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateLayerMutation = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteLayerMutation = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateNavigationMutation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateNavigationMutation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteNavigationMutation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type CreatePOIMutation = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePOIMutation = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeletePOIMutation = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreatePlanMutation = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePlanMutation = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type DeletePlanMutation = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateDomainMutation = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateDomainMutation = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteDomainMutation = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCommentMutation = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCommentMutation = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCommentMutation = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateFeatureMutation = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateFeatureMutation = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteFeatureMutation = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateHashtagMutation = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateHashtagMutation = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteHashtagMutation = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateProfileMutation = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateProfileMutation = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteProfileMutation = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateOrganisationMutation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateOrganisationMutation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteOrganisationMutation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreatePropertyMutation = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePropertyMutation = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeletePropertyMutation = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateMissionMutation = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateMissionMutation = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteMissionMutation = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateVisitTemplateMutation = {
  __typename: "VisitTemplate";
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userMissions?: {
    __typename: "ModelMissionConnection";
    items: Array<{
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateVisitTemplateMutation = {
  __typename: "VisitTemplate";
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userMissions?: {
    __typename: "ModelMissionConnection";
    items: Array<{
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteVisitTemplateMutation = {
  __typename: "VisitTemplate";
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userMissions?: {
    __typename: "ModelMissionConnection";
    items: Array<{
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCaptureMutation = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCaptureMutation = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCaptureMutation = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateNodeMutation = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateNodeMutation = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteNodeMutation = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type GetChannelQuery = {
  __typename: "Channel";
  name: string;
  data: string;
};

export type GetChatMessageQuery = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListChatMessagesQuery = {
  __typename: "ModelChatMessageConnection";
  items: Array<{
    __typename: "ChatMessage";
    id: string;
    message: string;
    type?: ChatMessageType | null;
    visitTemplateID?: string | null;
    visitTemplate?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    authorID?: string | null;
    author?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    timestamp?: number | null;
    receiver?: string | null;
    toAll?: boolean | null;
    zoomChatRecord?: {
      __typename: "ZoomChatRecord";
      id?: string | null;
      message?: string | null;
      sender?: {
        __typename: "ZoomUser";
        name?: string | null;
        userId?: number | null;
      } | null;
      receiver?: {
        __typename: "ZoomUser";
        name?: string | null;
        userId?: number | null;
      } | null;
      timestamp?: number | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ChatMessagesByTypeQuery = {
  __typename: "ModelChatMessageConnection";
  items: Array<{
    __typename: "ChatMessage";
    id: string;
    message: string;
    type?: ChatMessageType | null;
    visitTemplateID?: string | null;
    visitTemplate?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    authorID?: string | null;
    author?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    timestamp?: number | null;
    receiver?: string | null;
    toAll?: boolean | null;
    zoomChatRecord?: {
      __typename: "ZoomChatRecord";
      id?: string | null;
      message?: string | null;
      sender?: {
        __typename: "ZoomUser";
        name?: string | null;
        userId?: number | null;
      } | null;
      receiver?: {
        __typename: "ZoomUser";
        name?: string | null;
        userId?: number | null;
      } | null;
      timestamp?: number | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ChatMessagesByVisitQuery = {
  __typename: "ModelChatMessageConnection";
  items: Array<{
    __typename: "ChatMessage";
    id: string;
    message: string;
    type?: ChatMessageType | null;
    visitTemplateID?: string | null;
    visitTemplate?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    authorID?: string | null;
    author?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    timestamp?: number | null;
    receiver?: string | null;
    toAll?: boolean | null;
    zoomChatRecord?: {
      __typename: "ZoomChatRecord";
      id?: string | null;
      message?: string | null;
      sender?: {
        __typename: "ZoomUser";
        name?: string | null;
        userId?: number | null;
      } | null;
      receiver?: {
        __typename: "ZoomUser";
        name?: string | null;
        userId?: number | null;
      } | null;
      timestamp?: number | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetSpaceQuery = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ListSpacesQuery = {
  __typename: "ModelSpaceConnection";
  items: Array<{
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetZoneQuery = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListZonesQuery = {
  __typename: "ModelZoneConnection";
  items: Array<{
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ZonesByZoneQuery = {
  __typename: "ModelZoneConnection";
  items: Array<{
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ZonesBySpaceQuery = {
  __typename: "ModelZoneConnection";
  items: Array<{
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetLayerQuery = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListLayersQuery = {
  __typename: "ModelLayerConnection";
  items: Array<{
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type LayersByOrganisationQuery = {
  __typename: "ModelLayerConnection";
  items: Array<{
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetNavigationQuery = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ListNavigationsQuery = {
  __typename: "ModelNavigationConnection";
  items: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type NavigationsByMatterportIDBySpaceQuery = {
  __typename: "ModelNavigationConnection";
  items: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type NavigationsByNodeQuery = {
  __typename: "ModelNavigationConnection";
  items: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetPOIQuery = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListPOISQuery = {
  __typename: "ModelPOIConnection";
  items: Array<{
    __typename: "POI";
    id?: string | null;
    coordinate?: string | null;
    specific?: boolean | null;
    private?: boolean | null;
    global?: boolean | null;
    type?: PoiType | null;
    elementID?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    category?: Array<string | null> | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    metadata?: string | null;
    tagIcon?: string | null;
    tagDescription?: string | null;
    tagImageID?: string | null;
    matterportSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PoisByTypeQuery = {
  __typename: "ModelPOIConnection";
  items: Array<{
    __typename: "POI";
    id?: string | null;
    coordinate?: string | null;
    specific?: boolean | null;
    private?: boolean | null;
    global?: boolean | null;
    type?: PoiType | null;
    elementID?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    category?: Array<string | null> | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    metadata?: string | null;
    tagIcon?: string | null;
    tagDescription?: string | null;
    tagImageID?: string | null;
    matterportSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PoisByElementQuery = {
  __typename: "ModelPOIConnection";
  items: Array<{
    __typename: "POI";
    id?: string | null;
    coordinate?: string | null;
    specific?: boolean | null;
    private?: boolean | null;
    global?: boolean | null;
    type?: PoiType | null;
    elementID?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    category?: Array<string | null> | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    metadata?: string | null;
    tagIcon?: string | null;
    tagDescription?: string | null;
    tagImageID?: string | null;
    matterportSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetPlanQuery = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ListPlansQuery = {
  __typename: "ModelPlanConnection";
  items: Array<{
    __typename: "Plan";
    id: string;
    name?: string | null;
    annexe?: string | null;
    calibration?: string | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCurrentForZone?: boolean | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isModified?: boolean | null;
    isImportedMatterport?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PlansByZoneQuery = {
  __typename: "ModelPlanConnection";
  items: Array<{
    __typename: "Plan";
    id: string;
    name?: string | null;
    annexe?: string | null;
    calibration?: string | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCurrentForZone?: boolean | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isModified?: boolean | null;
    isImportedMatterport?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PlansBySpaceQuery = {
  __typename: "ModelPlanConnection";
  items: Array<{
    __typename: "Plan";
    id: string;
    name?: string | null;
    annexe?: string | null;
    calibration?: string | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCurrentForZone?: boolean | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isModified?: boolean | null;
    isImportedMatterport?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetDomainQuery = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type ListDomainsQuery = {
  __typename: "ModelDomainConnection";
  items: Array<{
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetCommentQuery = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListCommentsQuery = {
  __typename: "ModelCommentConnection";
  items: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type CommentsBySpaceQuery = {
  __typename: "ModelCommentConnection";
  items: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type CommentsByFeatureQuery = {
  __typename: "ModelCommentConnection";
  items: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetFeatureQuery = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type ListFeaturesQuery = {
  __typename: "ModelFeatureConnection";
  items: Array<{
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type FeaturesBySpaceQuery = {
  __typename: "ModelFeatureConnection";
  items: Array<{
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type FeaturesByDomainQuery = {
  __typename: "ModelFeatureConnection";
  items: Array<{
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetHashtagQuery = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListHashtagsQuery = {
  __typename: "ModelHashtagConnection";
  items: Array<{
    __typename: "Hashtag";
    id?: string | null;
    name?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type HashtagsBySpaceQuery = {
  __typename: "ModelHashtagConnection";
  items: Array<{
    __typename: "Hashtag";
    id?: string | null;
    name?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetProfileQuery = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListProfilesQuery = {
  __typename: "ModelProfileConnection";
  items: Array<{
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ProfilesByUserIDQuery = {
  __typename: "ModelProfileConnection";
  items: Array<{
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetOrganisationQuery = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListOrganisationsQuery = {
  __typename: "ModelOrganisationConnection";
  items: Array<{
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OrganisationsByTokenQuery = {
  __typename: "ModelOrganisationConnection";
  items: Array<{
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OrganisationsByStripeAccountQuery = {
  __typename: "ModelOrganisationConnection";
  items: Array<{
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetPropertyQuery = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListPropertiesQuery = {
  __typename: "ModelPropertyConnection";
  items: Array<{
    __typename: "Property";
    id?: string | null;
    type: PropertyType;
    deletedAt?: number | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PropertiesByOrganisationQuery = {
  __typename: "ModelPropertyConnection";
  items: Array<{
    __typename: "Property";
    id?: string | null;
    type: PropertyType;
    deletedAt?: number | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PropertiesBySpaceQuery = {
  __typename: "ModelPropertyConnection";
  items: Array<{
    __typename: "Property";
    id?: string | null;
    type: PropertyType;
    deletedAt?: number | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetMissionQuery = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ListMissionsQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByOrderedOrganisationQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByOrderedOrganisationBySpaceQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByOrganisationQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByUserQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsBySpaceQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsBySpaceByRoleQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByZoneByRoleQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByZoneQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByTemplateQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetVisitTemplateQuery = {
  __typename: "VisitTemplate";
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userMissions?: {
    __typename: "ModelMissionConnection";
    items: Array<{
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ListVisitTemplatesQuery = {
  __typename: "ModelVisitTemplateConnection";
  items: Array<{
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type TemplatesBySpaceQuery = {
  __typename: "ModelVisitTemplateConnection";
  items: Array<{
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type TemplatesByZoneQuery = {
  __typename: "ModelVisitTemplateConnection";
  items: Array<{
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetCaptureQuery = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListCapturesQuery = {
  __typename: "ModelCaptureConnection";
  items: Array<{
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type CapturesBySpaceQuery = {
  __typename: "ModelCaptureConnection";
  items: Array<{
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetNodeQuery = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListNodesQuery = {
  __typename: "ModelNodeConnection";
  items: Array<{
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type NodesByCaptureQuery = {
  __typename: "ModelNodeConnection";
  items: Array<{
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OnCreateMissionSubscription = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateMissionSubscription = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteMissionSubscription = {
  __typename: "Mission";
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  domains?: Array<string | null> | null;
  templateMissionID?: string | null;
  templateMission?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  locale?: Locale | null;
  isInWaitingRoom?: boolean | null;
  blockedInChat?: boolean | null;
  connectedToLiveAt?: Array<string | null> | null;
  disconnectedFromLiveAt?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateVisitTemplateSubscription = {
  __typename: "VisitTemplate";
  id?: string | null;
  title?: string | null;
  level?: LevelStatus | null;
  description?: string | null;
  metadata?: string | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userMissions?: {
    __typename: "ModelMissionConnection";
    items: Array<{
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  locale?: Locale | null;
  realStartedAt?: number | null;
  realEndedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type SubscribeToChannelSubscription = {
  __typename: "Channel";
  name: string;
  data: string;
};

export type OnCreateChatMessageSubscription = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateChatMessageSubscription = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteChatMessageSubscription = {
  __typename: "ChatMessage";
  id: string;
  message: string;
  type?: ChatMessageType | null;
  visitTemplateID?: string | null;
  visitTemplate?: {
    __typename: "VisitTemplate";
    id?: string | null;
    title?: string | null;
    level?: LevelStatus | null;
    description?: string | null;
    metadata?: string | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userMissions?: {
      __typename: "ModelMissionConnection";
      items: Array<{
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    locale?: Locale | null;
    realStartedAt?: number | null;
    realEndedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  authorID?: string | null;
  author?: {
    __typename: "Profile";
    id?: string | null;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  timestamp?: number | null;
  receiver?: string | null;
  toAll?: boolean | null;
  zoomChatRecord?: {
    __typename: "ZoomChatRecord";
    id?: string | null;
    message?: string | null;
    sender?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    receiver?: {
      __typename: "ZoomUser";
      name?: string | null;
      userId?: number | null;
    } | null;
    timestamp?: number | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateSpaceSubscription = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateSpaceSubscription = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteSpaceSubscription = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  constructionYear?: string | null;
  classEnergyConsumption?: string | null;
  classGes?: string | null;
  status?: SpaceStatus | null;
  guestLink?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  attachments?: Array<{
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateZoneSubscription = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateZoneSubscription = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteZoneSubscription = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id?: string | null;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  audioID?: string | null;
  audio?: {
    __typename: "Comment";
    id: string;
    title: string;
    description?: string | null;
    annexe?: string | null;
    metadata?: string | null;
    ownerID?: string | null;
    owner?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: CommentType | null;
    dimensions?: Array<number | null> | null;
    featureID?: string | null;
    feature?: {
      __typename: "Feature";
      id?: string | null;
      title?: string | null;
      description?: string | null;
      shortDescription?: string | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      ownerMissionID?: string | null;
      ownerMission?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      level?: LevelStatus | null;
      comments?: {
        __typename: "ModelCommentConnection";
        nextToken?: string | null;
      } | null;
      index?: number | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: FeatureType | null;
      archivedForMissionID?: Array<string | null> | null;
      stripeProductID?: string | null;
      stripePriceID?: string | null;
      bookingPriceMetadata?: string | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      hashtags?: Array<string | null> | null;
      locale?: Locale | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCoverImage?: boolean | null;
    index?: number | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shownInTag?: boolean | null;
    externalLink?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  startSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateLayerSubscription = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateLayerSubscription = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteLayerSubscription = {
  __typename: "Layer";
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateNavigationSubscription = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateNavigationSubscription = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteNavigationSubscription = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id?: string | null;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreatePOISubscription = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdatePOISubscription = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeletePOISubscription = {
  __typename: "POI";
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreatePlanSubscription = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdatePlanSubscription = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeletePlanSubscription = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateDomainSubscription = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateDomainSubscription = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteDomainSubscription = {
  __typename: "Domain";
  id: string;
  name: string;
  slug?: string | null;
  abbreviation?: string | null;
  description?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  parentID?: string | null;
  parent?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  children?: {
    __typename: "ModelDomainConnection";
    items: Array<{
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  type?: DomainType | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateCommentSubscription = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateCommentSubscription = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteCommentSubscription = {
  __typename: "Comment";
  id: string;
  title: string;
  description?: string | null;
  annexe?: string | null;
  metadata?: string | null;
  ownerID?: string | null;
  owner?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: CommentType | null;
  dimensions?: Array<number | null> | null;
  featureID?: string | null;
  feature?: {
    __typename: "Feature";
    id?: string | null;
    title?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    ownerMissionID?: string | null;
    ownerMission?: {
      __typename: "Mission";
      id?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      emailStatus?: EmailStatus | null;
      description?: string | null;
      metadata?: string | null;
      groups?: Array<string | null> | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      orderedOrganisationID?: string | null;
      orderedOrganisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userID: string;
      user?: {
        __typename: "Profile";
        id?: string | null;
        userID: string;
        avatar?: string | null;
        token?: string | null;
        tokenExpiredAt?: number | null;
        status?: ProfileStatus | null;
        metadata?: string | null;
        deletedAt?: number | null;
        lastConnectedAt?: number | null;
        pseudo?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      domains?: Array<string | null> | null;
      templateMissionID?: string | null;
      templateMission?: {
        __typename: "VisitTemplate";
        id?: string | null;
        title?: string | null;
        level?: LevelStatus | null;
        description?: string | null;
        metadata?: string | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        organisationID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        locale?: Locale | null;
        realStartedAt?: number | null;
        realEndedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      locale?: Locale | null;
      isInWaitingRoom?: boolean | null;
      blockedInChat?: boolean | null;
      connectedToLiveAt?: Array<string | null> | null;
      disconnectedFromLiveAt?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    level?: LevelStatus | null;
    comments?: {
      __typename: "ModelCommentConnection";
      items: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    index?: number | null;
    domainID?: string | null;
    domain?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    type?: FeatureType | null;
    archivedForMissionID?: Array<string | null> | null;
    stripeProductID?: string | null;
    stripePriceID?: string | null;
    bookingPriceMetadata?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id?: string | null;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        domainID?: string | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    hashtags?: Array<string | null> | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCoverImage?: boolean | null;
  index?: number | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shownInTag?: boolean | null;
  externalLink?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateFeatureSubscription = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateFeatureSubscription = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteFeatureSubscription = {
  __typename: "Feature";
  id?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  ownerMissionID?: string | null;
  ownerMission?: {
    __typename: "Mission";
    id?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id?: string | null;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    domains?: Array<string | null> | null;
    templateMissionID?: string | null;
    templateMission?: {
      __typename: "VisitTemplate";
      id?: string | null;
      title?: string | null;
      level?: LevelStatus | null;
      description?: string | null;
      metadata?: string | null;
      deletedAt?: number | null;
      startDateTime?: string | null;
      endDateTime?: string | null;
      hashtags?: Array<string | null> | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      userMissions?: {
        __typename: "ModelMissionConnection";
        nextToken?: string | null;
      } | null;
      locale?: Locale | null;
      realStartedAt?: number | null;
      realEndedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    locale?: Locale | null;
    isInWaitingRoom?: boolean | null;
    blockedInChat?: boolean | null;
    connectedToLiveAt?: Array<string | null> | null;
    disconnectedFromLiveAt?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  level?: LevelStatus | null;
  comments?: {
    __typename: "ModelCommentConnection";
    items: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  index?: number | null;
  domainID?: string | null;
  domain?: {
    __typename: "Domain";
    id: string;
    name: string;
    slug?: string | null;
    abbreviation?: string | null;
    description?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentID?: string | null;
    parent?: {
      __typename: "Domain";
      id: string;
      name: string;
      slug?: string | null;
      abbreviation?: string | null;
      description?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      parentID?: string | null;
      parent?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      children?: {
        __typename: "ModelDomainConnection";
        nextToken?: string | null;
      } | null;
      type?: DomainType | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: "ModelDomainConnection";
      items: Array<{
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    type?: DomainType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  type?: FeatureType | null;
  archivedForMissionID?: Array<string | null> | null;
  stripeProductID?: string | null;
  stripePriceID?: string | null;
  bookingPriceMetadata?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id?: string | null;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      domainID?: string | null;
      domain?: {
        __typename: "Domain";
        id: string;
        name: string;
        slug?: string | null;
        abbreviation?: string | null;
        description?: string | null;
        organisationID?: string | null;
        parentID?: string | null;
        type?: DomainType | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  hashtags?: Array<string | null> | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateHashtagSubscription = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateHashtagSubscription = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteHashtagSubscription = {
  __typename: "Hashtag";
  id?: string | null;
  name?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateProfileSubscription = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateProfileSubscription = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteProfileSubscription = {
  __typename: "Profile";
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateOrganisationSubscription = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateOrganisationSubscription = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteOrganisationSubscription = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  properties?: {
    __typename: "ModelPropertyConnection";
    items: Array<{
      __typename: "Property";
      id?: string | null;
      type: PropertyType;
      deletedAt?: number | null;
      organisationID: string;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID: string;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zoneID?: string | null;
      zone?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  shareToken?: string | null;
  tokenExpiresAt?: number | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeToken?: string | null;
  stripeChargesEnabled?: boolean | null;
  contactDetails?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreatePropertySubscription = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdatePropertySubscription = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeletePropertySubscription = {
  __typename: "Property";
  id?: string | null;
  type: PropertyType;
  deletedAt?: number | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    shareToken?: string | null;
    tokenExpiresAt?: number | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeToken?: string | null;
    stripeChargesEnabled?: boolean | null;
    contactDetails?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    properties?: {
      __typename: "ModelPropertyConnection";
      items: Array<{
        __typename: "Property";
        id?: string | null;
        type: PropertyType;
        deletedAt?: number | null;
        organisationID: string;
        spaceID: string;
        zoneID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    constructionYear?: string | null;
    classEnergyConsumption?: string | null;
    classGes?: string | null;
    status?: SpaceStatus | null;
    guestLink?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      shareToken?: string | null;
      tokenExpiresAt?: number | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeToken?: string | null;
      stripeChargesEnabled?: boolean | null;
      contactDetails?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    attachments?: Array<{
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        audioID?: string | null;
        startSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id?: string | null;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      audioID?: string | null;
      audio?: {
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      startSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      properties?: {
        __typename: "ModelPropertyConnection";
        nextToken?: string | null;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      constructionYear?: string | null;
      classEnergyConsumption?: string | null;
      classGes?: string | null;
      status?: SpaceStatus | null;
      guestLink?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      attachments?: Array<{
        __typename: "Comment";
        id: string;
        title: string;
        description?: string | null;
        annexe?: string | null;
        metadata?: string | null;
        ownerID?: string | null;
        spaceID?: string | null;
        type?: CommentType | null;
        dimensions?: Array<number | null> | null;
        featureID?: string | null;
        isCoverImage?: boolean | null;
        index?: number | null;
        shownInTag?: boolean | null;
        externalLink?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id?: string | null;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        shareToken?: string | null;
        tokenExpiresAt?: number | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeToken?: string | null;
        stripeChargesEnabled?: boolean | null;
        contactDetails?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    audioID?: string | null;
    audio?: {
      __typename: "Comment";
      id: string;
      title: string;
      description?: string | null;
      annexe?: string | null;
      metadata?: string | null;
      ownerID?: string | null;
      owner?: {
        __typename: "Mission";
        id?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        emailStatus?: EmailStatus | null;
        description?: string | null;
        metadata?: string | null;
        groups?: Array<string | null> | null;
        deletedAt?: number | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        hashtags?: Array<string | null> | null;
        orderedOrganisationID?: string | null;
        organisationID: string;
        userID: string;
        spaceID?: string | null;
        zoneID?: string | null;
        domains?: Array<string | null> | null;
        templateMissionID?: string | null;
        locale?: Locale | null;
        isInWaitingRoom?: boolean | null;
        blockedInChat?: boolean | null;
        connectedToLiveAt?: Array<string | null> | null;
        disconnectedFromLiveAt?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        constructionYear?: string | null;
        classEnergyConsumption?: string | null;
        classGes?: string | null;
        status?: SpaceStatus | null;
        guestLink?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      type?: CommentType | null;
      dimensions?: Array<number | null> | null;
      featureID?: string | null;
      feature?: {
        __typename: "Feature";
        id?: string | null;
        title?: string | null;
        description?: string | null;
        shortDescription?: string | null;
        spaceID: string;
        ownerMissionID?: string | null;
        level?: LevelStatus | null;
        index?: number | null;
        domainID?: string | null;
        type?: FeatureType | null;
        archivedForMissionID?: Array<string | null> | null;
        stripeProductID?: string | null;
        stripePriceID?: string | null;
        bookingPriceMetadata?: string | null;
        hashtags?: Array<string | null> | null;
        locale?: Locale | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isCoverImage?: boolean | null;
      index?: number | null;
      pois?: {
        __typename: "ModelPOIConnection";
        nextToken?: string | null;
      } | null;
      shownInTag?: boolean | null;
      externalLink?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    startSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateCaptureSubscription = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateCaptureSubscription = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteCaptureSubscription = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id?: string | null;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateNodeSubscription = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateNodeSubscription = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteNodeSubscription = {
  __typename: "Node";
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id?: string | null;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async PublishToChannel(
    name: string,
    data: string
  ): Promise<PublishToChannelMutation> {
    const statement = `mutation PublishToChannel($name: String!, $data: AWSJSON!) {
        publishToChannel(name: $name, data: $data) {
          __typename
          name
          data
        }
      }`;
    const gqlAPIServiceArguments: any = {
      name,
      data
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PublishToChannelMutation>response.data.publishToChannel;
  }
  async CreateChatMessage(
    input: CreateChatMessageInput,
    condition?: ModelChatMessageConditionInput
  ): Promise<CreateChatMessageMutation> {
    const statement = `mutation CreateChatMessage($input: CreateChatMessageInput!, $condition: ModelChatMessageConditionInput) {
        createChatMessage(input: $input, condition: $condition) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateChatMessageMutation>response.data.createChatMessage;
  }
  async UpdateChatMessage(
    input: UpdateChatMessageInput,
    condition?: ModelChatMessageConditionInput
  ): Promise<UpdateChatMessageMutation> {
    const statement = `mutation UpdateChatMessage($input: UpdateChatMessageInput!, $condition: ModelChatMessageConditionInput) {
        updateChatMessage(input: $input, condition: $condition) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateChatMessageMutation>response.data.updateChatMessage;
  }
  async DeleteChatMessage(
    input: DeleteChatMessageInput,
    condition?: ModelChatMessageConditionInput
  ): Promise<DeleteChatMessageMutation> {
    const statement = `mutation DeleteChatMessage($input: DeleteChatMessageInput!, $condition: ModelChatMessageConditionInput) {
        deleteChatMessage(input: $input, condition: $condition) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteChatMessageMutation>response.data.deleteChatMessage;
  }
  async CreateSpace(
    input: CreateSpaceInput,
    condition?: ModelSpaceConditionInput
  ): Promise<CreateSpaceMutation> {
    const statement = `mutation CreateSpace($input: CreateSpaceInput!, $condition: ModelSpaceConditionInput) {
        createSpace(input: $input, condition: $condition) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSpaceMutation>response.data.createSpace;
  }
  async UpdateSpace(
    input: UpdateSpaceInput,
    condition?: ModelSpaceConditionInput
  ): Promise<UpdateSpaceMutation> {
    const statement = `mutation UpdateSpace($input: UpdateSpaceInput!, $condition: ModelSpaceConditionInput) {
        updateSpace(input: $input, condition: $condition) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSpaceMutation>response.data.updateSpace;
  }
  async DeleteSpace(
    input: DeleteSpaceInput,
    condition?: ModelSpaceConditionInput
  ): Promise<DeleteSpaceMutation> {
    const statement = `mutation DeleteSpace($input: DeleteSpaceInput!, $condition: ModelSpaceConditionInput) {
        deleteSpace(input: $input, condition: $condition) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSpaceMutation>response.data.deleteSpace;
  }
  async CreateZone(
    input: CreateZoneInput,
    condition?: ModelZoneConditionInput
  ): Promise<CreateZoneMutation> {
    const statement = `mutation CreateZone($input: CreateZoneInput!, $condition: ModelZoneConditionInput) {
        createZone(input: $input, condition: $condition) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateZoneMutation>response.data.createZone;
  }
  async UpdateZone(
    input: UpdateZoneInput,
    condition?: ModelZoneConditionInput
  ): Promise<UpdateZoneMutation> {
    const statement = `mutation UpdateZone($input: UpdateZoneInput!, $condition: ModelZoneConditionInput) {
        updateZone(input: $input, condition: $condition) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateZoneMutation>response.data.updateZone;
  }
  async DeleteZone(
    input: DeleteZoneInput,
    condition?: ModelZoneConditionInput
  ): Promise<DeleteZoneMutation> {
    const statement = `mutation DeleteZone($input: DeleteZoneInput!, $condition: ModelZoneConditionInput) {
        deleteZone(input: $input, condition: $condition) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteZoneMutation>response.data.deleteZone;
  }
  async CreateLayer(
    input: CreateLayerInput,
    condition?: ModelLayerConditionInput
  ): Promise<CreateLayerMutation> {
    const statement = `mutation CreateLayer($input: CreateLayerInput!, $condition: ModelLayerConditionInput) {
        createLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateLayerMutation>response.data.createLayer;
  }
  async UpdateLayer(
    input: UpdateLayerInput,
    condition?: ModelLayerConditionInput
  ): Promise<UpdateLayerMutation> {
    const statement = `mutation UpdateLayer($input: UpdateLayerInput!, $condition: ModelLayerConditionInput) {
        updateLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateLayerMutation>response.data.updateLayer;
  }
  async DeleteLayer(
    input: DeleteLayerInput,
    condition?: ModelLayerConditionInput
  ): Promise<DeleteLayerMutation> {
    const statement = `mutation DeleteLayer($input: DeleteLayerInput!, $condition: ModelLayerConditionInput) {
        deleteLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteLayerMutation>response.data.deleteLayer;
  }
  async CreateNavigation(
    input: CreateNavigationInput,
    condition?: ModelNavigationConditionInput
  ): Promise<CreateNavigationMutation> {
    const statement = `mutation CreateNavigation($input: CreateNavigationInput!, $condition: ModelNavigationConditionInput) {
        createNavigation(input: $input, condition: $condition) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNavigationMutation>response.data.createNavigation;
  }
  async UpdateNavigation(
    input: UpdateNavigationInput,
    condition?: ModelNavigationConditionInput
  ): Promise<UpdateNavigationMutation> {
    const statement = `mutation UpdateNavigation($input: UpdateNavigationInput!, $condition: ModelNavigationConditionInput) {
        updateNavigation(input: $input, condition: $condition) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNavigationMutation>response.data.updateNavigation;
  }
  async DeleteNavigation(
    input: DeleteNavigationInput,
    condition?: ModelNavigationConditionInput
  ): Promise<DeleteNavigationMutation> {
    const statement = `mutation DeleteNavigation($input: DeleteNavigationInput!, $condition: ModelNavigationConditionInput) {
        deleteNavigation(input: $input, condition: $condition) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNavigationMutation>response.data.deleteNavigation;
  }
  async CreatePOI(
    input: CreatePOIInput,
    condition?: ModelPOIConditionInput
  ): Promise<CreatePOIMutation> {
    const statement = `mutation CreatePOI($input: CreatePOIInput!, $condition: ModelPOIConditionInput) {
        createPOI(input: $input, condition: $condition) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePOIMutation>response.data.createPOI;
  }
  async UpdatePOI(
    input: UpdatePOIInput,
    condition?: ModelPOIConditionInput
  ): Promise<UpdatePOIMutation> {
    const statement = `mutation UpdatePOI($input: UpdatePOIInput!, $condition: ModelPOIConditionInput) {
        updatePOI(input: $input, condition: $condition) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePOIMutation>response.data.updatePOI;
  }
  async DeletePOI(
    input: DeletePOIInput,
    condition?: ModelPOIConditionInput
  ): Promise<DeletePOIMutation> {
    const statement = `mutation DeletePOI($input: DeletePOIInput!, $condition: ModelPOIConditionInput) {
        deletePOI(input: $input, condition: $condition) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePOIMutation>response.data.deletePOI;
  }
  async CreatePlan(
    input: CreatePlanInput,
    condition?: ModelPlanConditionInput
  ): Promise<CreatePlanMutation> {
    const statement = `mutation CreatePlan($input: CreatePlanInput!, $condition: ModelPlanConditionInput) {
        createPlan(input: $input, condition: $condition) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePlanMutation>response.data.createPlan;
  }
  async UpdatePlan(
    input: UpdatePlanInput,
    condition?: ModelPlanConditionInput
  ): Promise<UpdatePlanMutation> {
    const statement = `mutation UpdatePlan($input: UpdatePlanInput!, $condition: ModelPlanConditionInput) {
        updatePlan(input: $input, condition: $condition) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePlanMutation>response.data.updatePlan;
  }
  async DeletePlan(
    input: DeletePlanInput,
    condition?: ModelPlanConditionInput
  ): Promise<DeletePlanMutation> {
    const statement = `mutation DeletePlan($input: DeletePlanInput!, $condition: ModelPlanConditionInput) {
        deletePlan(input: $input, condition: $condition) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePlanMutation>response.data.deletePlan;
  }
  async CreateDomain(
    input: CreateDomainInput,
    condition?: ModelDomainConditionInput
  ): Promise<CreateDomainMutation> {
    const statement = `mutation CreateDomain($input: CreateDomainInput!, $condition: ModelDomainConditionInput) {
        createDomain(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateDomainMutation>response.data.createDomain;
  }
  async UpdateDomain(
    input: UpdateDomainInput,
    condition?: ModelDomainConditionInput
  ): Promise<UpdateDomainMutation> {
    const statement = `mutation UpdateDomain($input: UpdateDomainInput!, $condition: ModelDomainConditionInput) {
        updateDomain(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateDomainMutation>response.data.updateDomain;
  }
  async DeleteDomain(
    input: DeleteDomainInput,
    condition?: ModelDomainConditionInput
  ): Promise<DeleteDomainMutation> {
    const statement = `mutation DeleteDomain($input: DeleteDomainInput!, $condition: ModelDomainConditionInput) {
        deleteDomain(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteDomainMutation>response.data.deleteDomain;
  }
  async CreateComment(
    input: CreateCommentInput,
    condition?: ModelCommentConditionInput
  ): Promise<CreateCommentMutation> {
    const statement = `mutation CreateComment($input: CreateCommentInput!, $condition: ModelCommentConditionInput) {
        createComment(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCommentMutation>response.data.createComment;
  }
  async UpdateComment(
    input: UpdateCommentInput,
    condition?: ModelCommentConditionInput
  ): Promise<UpdateCommentMutation> {
    const statement = `mutation UpdateComment($input: UpdateCommentInput!, $condition: ModelCommentConditionInput) {
        updateComment(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCommentMutation>response.data.updateComment;
  }
  async DeleteComment(
    input: DeleteCommentInput,
    condition?: ModelCommentConditionInput
  ): Promise<DeleteCommentMutation> {
    const statement = `mutation DeleteComment($input: DeleteCommentInput!, $condition: ModelCommentConditionInput) {
        deleteComment(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCommentMutation>response.data.deleteComment;
  }
  async CreateFeature(
    input: CreateFeatureInput,
    condition?: ModelFeatureConditionInput
  ): Promise<CreateFeatureMutation> {
    const statement = `mutation CreateFeature($input: CreateFeatureInput!, $condition: ModelFeatureConditionInput) {
        createFeature(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFeatureMutation>response.data.createFeature;
  }
  async UpdateFeature(
    input: UpdateFeatureInput,
    condition?: ModelFeatureConditionInput
  ): Promise<UpdateFeatureMutation> {
    const statement = `mutation UpdateFeature($input: UpdateFeatureInput!, $condition: ModelFeatureConditionInput) {
        updateFeature(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFeatureMutation>response.data.updateFeature;
  }
  async DeleteFeature(
    input: DeleteFeatureInput,
    condition?: ModelFeatureConditionInput
  ): Promise<DeleteFeatureMutation> {
    const statement = `mutation DeleteFeature($input: DeleteFeatureInput!, $condition: ModelFeatureConditionInput) {
        deleteFeature(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFeatureMutation>response.data.deleteFeature;
  }
  async CreateHashtag(
    input: CreateHashtagInput,
    condition?: ModelHashtagConditionInput
  ): Promise<CreateHashtagMutation> {
    const statement = `mutation CreateHashtag($input: CreateHashtagInput!, $condition: ModelHashtagConditionInput) {
        createHashtag(input: $input, condition: $condition) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateHashtagMutation>response.data.createHashtag;
  }
  async UpdateHashtag(
    input: UpdateHashtagInput,
    condition?: ModelHashtagConditionInput
  ): Promise<UpdateHashtagMutation> {
    const statement = `mutation UpdateHashtag($input: UpdateHashtagInput!, $condition: ModelHashtagConditionInput) {
        updateHashtag(input: $input, condition: $condition) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateHashtagMutation>response.data.updateHashtag;
  }
  async DeleteHashtag(
    input: DeleteHashtagInput,
    condition?: ModelHashtagConditionInput
  ): Promise<DeleteHashtagMutation> {
    const statement = `mutation DeleteHashtag($input: DeleteHashtagInput!, $condition: ModelHashtagConditionInput) {
        deleteHashtag(input: $input, condition: $condition) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteHashtagMutation>response.data.deleteHashtag;
  }
  async CreateProfile(
    input: CreateProfileInput,
    condition?: ModelProfileConditionInput
  ): Promise<CreateProfileMutation> {
    const statement = `mutation CreateProfile($input: CreateProfileInput!, $condition: ModelProfileConditionInput) {
        createProfile(input: $input, condition: $condition) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateProfileMutation>response.data.createProfile;
  }
  async UpdateProfile(
    input: UpdateProfileInput,
    condition?: ModelProfileConditionInput
  ): Promise<UpdateProfileMutation> {
    const statement = `mutation UpdateProfile($input: UpdateProfileInput!, $condition: ModelProfileConditionInput) {
        updateProfile(input: $input, condition: $condition) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateProfileMutation>response.data.updateProfile;
  }
  async DeleteProfile(
    input: DeleteProfileInput,
    condition?: ModelProfileConditionInput
  ): Promise<DeleteProfileMutation> {
    const statement = `mutation DeleteProfile($input: DeleteProfileInput!, $condition: ModelProfileConditionInput) {
        deleteProfile(input: $input, condition: $condition) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteProfileMutation>response.data.deleteProfile;
  }
  async CreateOrganisation(
    input: CreateOrganisationInput,
    condition?: ModelOrganisationConditionInput
  ): Promise<CreateOrganisationMutation> {
    const statement = `mutation CreateOrganisation($input: CreateOrganisationInput!, $condition: ModelOrganisationConditionInput) {
        createOrganisation(input: $input, condition: $condition) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateOrganisationMutation>response.data.createOrganisation;
  }
  async UpdateOrganisation(
    input: UpdateOrganisationInput,
    condition?: ModelOrganisationConditionInput
  ): Promise<UpdateOrganisationMutation> {
    const statement = `mutation UpdateOrganisation($input: UpdateOrganisationInput!, $condition: ModelOrganisationConditionInput) {
        updateOrganisation(input: $input, condition: $condition) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateOrganisationMutation>response.data.updateOrganisation;
  }
  async DeleteOrganisation(
    input: DeleteOrganisationInput,
    condition?: ModelOrganisationConditionInput
  ): Promise<DeleteOrganisationMutation> {
    const statement = `mutation DeleteOrganisation($input: DeleteOrganisationInput!, $condition: ModelOrganisationConditionInput) {
        deleteOrganisation(input: $input, condition: $condition) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteOrganisationMutation>response.data.deleteOrganisation;
  }
  async CreateProperty(
    input: CreatePropertyInput,
    condition?: ModelPropertyConditionInput
  ): Promise<CreatePropertyMutation> {
    const statement = `mutation CreateProperty($input: CreatePropertyInput!, $condition: ModelPropertyConditionInput) {
        createProperty(input: $input, condition: $condition) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePropertyMutation>response.data.createProperty;
  }
  async UpdateProperty(
    input: UpdatePropertyInput,
    condition?: ModelPropertyConditionInput
  ): Promise<UpdatePropertyMutation> {
    const statement = `mutation UpdateProperty($input: UpdatePropertyInput!, $condition: ModelPropertyConditionInput) {
        updateProperty(input: $input, condition: $condition) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePropertyMutation>response.data.updateProperty;
  }
  async DeleteProperty(
    input: DeletePropertyInput,
    condition?: ModelPropertyConditionInput
  ): Promise<DeletePropertyMutation> {
    const statement = `mutation DeleteProperty($input: DeletePropertyInput!, $condition: ModelPropertyConditionInput) {
        deleteProperty(input: $input, condition: $condition) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePropertyMutation>response.data.deleteProperty;
  }
  async CreateMission(
    input: CreateMissionInput,
    condition?: ModelMissionConditionInput
  ): Promise<CreateMissionMutation> {
    const statement = `mutation CreateMission($input: CreateMissionInput!, $condition: ModelMissionConditionInput) {
        createMission(input: $input, condition: $condition) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateMissionMutation>response.data.createMission;
  }
  async UpdateMission(
    input: UpdateMissionInput,
    condition?: ModelMissionConditionInput
  ): Promise<UpdateMissionMutation> {
    const statement = `mutation UpdateMission($input: UpdateMissionInput!, $condition: ModelMissionConditionInput) {
        updateMission(input: $input, condition: $condition) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateMissionMutation>response.data.updateMission;
  }
  async DeleteMission(
    input: DeleteMissionInput,
    condition?: ModelMissionConditionInput
  ): Promise<DeleteMissionMutation> {
    const statement = `mutation DeleteMission($input: DeleteMissionInput!, $condition: ModelMissionConditionInput) {
        deleteMission(input: $input, condition: $condition) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteMissionMutation>response.data.deleteMission;
  }
  async CreateVisitTemplate(
    input: CreateVisitTemplateInput,
    condition?: ModelVisitTemplateConditionInput
  ): Promise<CreateVisitTemplateMutation> {
    const statement = `mutation CreateVisitTemplate($input: CreateVisitTemplateInput!, $condition: ModelVisitTemplateConditionInput) {
        createVisitTemplate(input: $input, condition: $condition) {
          __typename
          id
          title
          level
          description
          metadata
          deletedAt
          startDateTime
          endDateTime
          hashtags
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          userMissions {
            __typename
            items {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            nextToken
          }
          locale
          realStartedAt
          realEndedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateVisitTemplateMutation>response.data.createVisitTemplate;
  }
  async UpdateVisitTemplate(
    input: UpdateVisitTemplateInput,
    condition?: ModelVisitTemplateConditionInput
  ): Promise<UpdateVisitTemplateMutation> {
    const statement = `mutation UpdateVisitTemplate($input: UpdateVisitTemplateInput!, $condition: ModelVisitTemplateConditionInput) {
        updateVisitTemplate(input: $input, condition: $condition) {
          __typename
          id
          title
          level
          description
          metadata
          deletedAt
          startDateTime
          endDateTime
          hashtags
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          userMissions {
            __typename
            items {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            nextToken
          }
          locale
          realStartedAt
          realEndedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateVisitTemplateMutation>response.data.updateVisitTemplate;
  }
  async DeleteVisitTemplate(
    input: DeleteVisitTemplateInput,
    condition?: ModelVisitTemplateConditionInput
  ): Promise<DeleteVisitTemplateMutation> {
    const statement = `mutation DeleteVisitTemplate($input: DeleteVisitTemplateInput!, $condition: ModelVisitTemplateConditionInput) {
        deleteVisitTemplate(input: $input, condition: $condition) {
          __typename
          id
          title
          level
          description
          metadata
          deletedAt
          startDateTime
          endDateTime
          hashtags
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          userMissions {
            __typename
            items {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            nextToken
          }
          locale
          realStartedAt
          realEndedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteVisitTemplateMutation>response.data.deleteVisitTemplate;
  }
  async CreateCapture(
    input: CreateCaptureInput,
    condition?: ModelCaptureConditionInput
  ): Promise<CreateCaptureMutation> {
    const statement = `mutation CreateCapture($input: CreateCaptureInput!, $condition: ModelCaptureConditionInput) {
        createCapture(input: $input, condition: $condition) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCaptureMutation>response.data.createCapture;
  }
  async UpdateCapture(
    input: UpdateCaptureInput,
    condition?: ModelCaptureConditionInput
  ): Promise<UpdateCaptureMutation> {
    const statement = `mutation UpdateCapture($input: UpdateCaptureInput!, $condition: ModelCaptureConditionInput) {
        updateCapture(input: $input, condition: $condition) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCaptureMutation>response.data.updateCapture;
  }
  async DeleteCapture(
    input: DeleteCaptureInput,
    condition?: ModelCaptureConditionInput
  ): Promise<DeleteCaptureMutation> {
    const statement = `mutation DeleteCapture($input: DeleteCaptureInput!, $condition: ModelCaptureConditionInput) {
        deleteCapture(input: $input, condition: $condition) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCaptureMutation>response.data.deleteCapture;
  }
  async CreateNode(
    input: CreateNodeInput,
    condition?: ModelNodeConditionInput
  ): Promise<CreateNodeMutation> {
    const statement = `mutation CreateNode($input: CreateNodeInput!, $condition: ModelNodeConditionInput) {
        createNode(input: $input, condition: $condition) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNodeMutation>response.data.createNode;
  }
  async UpdateNode(
    input: UpdateNodeInput,
    condition?: ModelNodeConditionInput
  ): Promise<UpdateNodeMutation> {
    const statement = `mutation UpdateNode($input: UpdateNodeInput!, $condition: ModelNodeConditionInput) {
        updateNode(input: $input, condition: $condition) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNodeMutation>response.data.updateNode;
  }
  async DeleteNode(
    input: DeleteNodeInput,
    condition?: ModelNodeConditionInput
  ): Promise<DeleteNodeMutation> {
    const statement = `mutation DeleteNode($input: DeleteNodeInput!, $condition: ModelNodeConditionInput) {
        deleteNode(input: $input, condition: $condition) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNodeMutation>response.data.deleteNode;
  }
  async GetChannel(): Promise<GetChannelQuery> {
    const statement = `query GetChannel {
        getChannel {
          __typename
          name
          data
        }
      }`;
    const response = (await API.graphql(graphqlOperation(statement))) as any;
    return <GetChannelQuery>response.data.getChannel;
  }
  async GetChatMessage(id: string): Promise<GetChatMessageQuery> {
    const statement = `query GetChatMessage($id: ID!) {
        getChatMessage(id: $id) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetChatMessageQuery>response.data.getChatMessage;
  }
  async ListChatMessages(
    filter?: ModelChatMessageFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListChatMessagesQuery> {
    const statement = `query ListChatMessages($filter: ModelChatMessageFilterInput, $limit: Int, $nextToken: String) {
        listChatMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            message
            type
            visitTemplateID
            visitTemplate {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            authorID
            author {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            timestamp
            receiver
            toAll
            zoomChatRecord {
              __typename
              id
              message
              sender {
                __typename
                name
                userId
              }
              receiver {
                __typename
                name
                userId
              }
              timestamp
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListChatMessagesQuery>response.data.listChatMessages;
  }
  async ChatMessagesByType(
    type: ChatMessageType,
    timestamp?: ModelIntKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelChatMessageFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ChatMessagesByTypeQuery> {
    const statement = `query ChatMessagesByType($type: ChatMessageType!, $timestamp: ModelIntKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelChatMessageFilterInput, $limit: Int, $nextToken: String) {
        chatMessagesByType(type: $type, timestamp: $timestamp, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            message
            type
            visitTemplateID
            visitTemplate {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            authorID
            author {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            timestamp
            receiver
            toAll
            zoomChatRecord {
              __typename
              id
              message
              sender {
                __typename
                name
                userId
              }
              receiver {
                __typename
                name
                userId
              }
              timestamp
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      type
    };
    if (timestamp) {
      gqlAPIServiceArguments.timestamp = timestamp;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ChatMessagesByTypeQuery>response.data.chatMessagesByType;
  }
  async ChatMessagesByVisit(
    visitTemplateID: string,
    timestamp?: ModelIntKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelChatMessageFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ChatMessagesByVisitQuery> {
    const statement = `query ChatMessagesByVisit($visitTemplateID: ID!, $timestamp: ModelIntKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelChatMessageFilterInput, $limit: Int, $nextToken: String) {
        chatMessagesByVisit(visitTemplateID: $visitTemplateID, timestamp: $timestamp, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            message
            type
            visitTemplateID
            visitTemplate {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            authorID
            author {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            timestamp
            receiver
            toAll
            zoomChatRecord {
              __typename
              id
              message
              sender {
                __typename
                name
                userId
              }
              receiver {
                __typename
                name
                userId
              }
              timestamp
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      visitTemplateID
    };
    if (timestamp) {
      gqlAPIServiceArguments.timestamp = timestamp;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ChatMessagesByVisitQuery>response.data.chatMessagesByVisit;
  }
  async GetSpace(id: string): Promise<GetSpaceQuery> {
    const statement = `query GetSpace($id: ID!) {
        getSpace(id: $id) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSpaceQuery>response.data.getSpace;
  }
  async ListSpaces(
    filter?: ModelSpaceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSpacesQuery> {
    const statement = `query ListSpaces($filter: ModelSpaceFilterInput, $limit: Int, $nextToken: String) {
        listSpaces(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSpacesQuery>response.data.listSpaces;
  }
  async GetZone(id: string): Promise<GetZoneQuery> {
    const statement = `query GetZone($id: ID!) {
        getZone(id: $id) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetZoneQuery>response.data.getZone;
  }
  async ListZones(
    filter?: ModelZoneFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListZonesQuery> {
    const statement = `query ListZones($filter: ModelZoneFilterInput, $limit: Int, $nextToken: String) {
        listZones(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListZonesQuery>response.data.listZones;
  }
  async ZonesByZone(
    parentID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelZoneFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ZonesByZoneQuery> {
    const statement = `query ZonesByZone($parentID: ID!, $sortDirection: ModelSortDirection, $filter: ModelZoneFilterInput, $limit: Int, $nextToken: String) {
        zonesByZone(parentID: $parentID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      parentID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ZonesByZoneQuery>response.data.zonesByZone;
  }
  async ZonesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelZoneFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ZonesBySpaceQuery> {
    const statement = `query ZonesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelZoneFilterInput, $limit: Int, $nextToken: String) {
        zonesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ZonesBySpaceQuery>response.data.zonesBySpace;
  }
  async GetLayer(id: string): Promise<GetLayerQuery> {
    const statement = `query GetLayer($id: ID!) {
        getLayer(id: $id) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetLayerQuery>response.data.getLayer;
  }
  async ListLayers(
    filter?: ModelLayerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListLayersQuery> {
    const statement = `query ListLayers($filter: ModelLayerFilterInput, $limit: Int, $nextToken: String) {
        listLayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListLayersQuery>response.data.listLayers;
  }
  async LayersByOrganisation(
    organisationID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelLayerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<LayersByOrganisationQuery> {
    const statement = `query LayersByOrganisation($organisationID: ID!, $sortDirection: ModelSortDirection, $filter: ModelLayerFilterInput, $limit: Int, $nextToken: String) {
        layersByOrganisation(organisationID: $organisationID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      organisationID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <LayersByOrganisationQuery>response.data.layersByOrganisation;
  }
  async GetNavigation(id: string): Promise<GetNavigationQuery> {
    const statement = `query GetNavigation($id: ID!) {
        getNavigation(id: $id) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNavigationQuery>response.data.getNavigation;
  }
  async ListNavigations(
    filter?: ModelNavigationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNavigationsQuery> {
    const statement = `query ListNavigations($filter: ModelNavigationFilterInput, $limit: Int, $nextToken: String) {
        listNavigations(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNavigationsQuery>response.data.listNavigations;
  }
  async NavigationsByMatterportIDBySpace(
    matterportSweepID: string,
    spaceID?: ModelIDKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelNavigationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<NavigationsByMatterportIDBySpaceQuery> {
    const statement = `query NavigationsByMatterportIDBySpace($matterportSweepID: String!, $spaceID: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelNavigationFilterInput, $limit: Int, $nextToken: String) {
        navigationsByMatterportIDBySpace(matterportSweepID: $matterportSweepID, spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      matterportSweepID
    };
    if (spaceID) {
      gqlAPIServiceArguments.spaceID = spaceID;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <NavigationsByMatterportIDBySpaceQuery>(
      response.data.navigationsByMatterportIDBySpace
    );
  }
  async NavigationsByNode(
    nodeID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelNavigationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<NavigationsByNodeQuery> {
    const statement = `query NavigationsByNode($nodeID: ID!, $sortDirection: ModelSortDirection, $filter: ModelNavigationFilterInput, $limit: Int, $nextToken: String) {
        navigationsByNode(nodeID: $nodeID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      nodeID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <NavigationsByNodeQuery>response.data.navigationsByNode;
  }
  async GetPOI(id: string): Promise<GetPOIQuery> {
    const statement = `query GetPOI($id: ID!) {
        getPOI(id: $id) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPOIQuery>response.data.getPOI;
  }
  async ListPOIS(
    filter?: ModelPOIFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPOISQuery> {
    const statement = `query ListPOIS($filter: ModelPOIFilterInput, $limit: Int, $nextToken: String) {
        listPOIS(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            coordinate
            specific
            private
            global
            type
            elementID
            level
            role
            category
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            metadata
            tagIcon
            tagDescription
            tagImageID
            matterportSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPOISQuery>response.data.listPOIS;
  }
  async PoisByType(
    type: PoiType,
    sortDirection?: ModelSortDirection,
    filter?: ModelPOIFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PoisByTypeQuery> {
    const statement = `query PoisByType($type: PoiType!, $sortDirection: ModelSortDirection, $filter: ModelPOIFilterInput, $limit: Int, $nextToken: String) {
        poisByType(type: $type, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            coordinate
            specific
            private
            global
            type
            elementID
            level
            role
            category
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            metadata
            tagIcon
            tagDescription
            tagImageID
            matterportSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      type
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PoisByTypeQuery>response.data.poisByType;
  }
  async PoisByElement(
    elementID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPOIFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PoisByElementQuery> {
    const statement = `query PoisByElement($elementID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPOIFilterInput, $limit: Int, $nextToken: String) {
        poisByElement(elementID: $elementID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            coordinate
            specific
            private
            global
            type
            elementID
            level
            role
            category
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            metadata
            tagIcon
            tagDescription
            tagImageID
            matterportSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      elementID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PoisByElementQuery>response.data.poisByElement;
  }
  async GetPlan(id: string): Promise<GetPlanQuery> {
    const statement = `query GetPlan($id: ID!) {
        getPlan(id: $id) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPlanQuery>response.data.getPlan;
  }
  async ListPlans(
    filter?: ModelPlanFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPlansQuery> {
    const statement = `query ListPlans($filter: ModelPlanFilterInput, $limit: Int, $nextToken: String) {
        listPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            annexe
            calibration
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            isCurrentForZone
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isModified
            isImportedMatterport
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPlansQuery>response.data.listPlans;
  }
  async PlansByZone(
    zoneID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPlanFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PlansByZoneQuery> {
    const statement = `query PlansByZone($zoneID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPlanFilterInput, $limit: Int, $nextToken: String) {
        plansByZone(zoneID: $zoneID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            annexe
            calibration
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            isCurrentForZone
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isModified
            isImportedMatterport
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      zoneID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PlansByZoneQuery>response.data.plansByZone;
  }
  async PlansBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPlanFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PlansBySpaceQuery> {
    const statement = `query PlansBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPlanFilterInput, $limit: Int, $nextToken: String) {
        plansBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            annexe
            calibration
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            isCurrentForZone
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isModified
            isImportedMatterport
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PlansBySpaceQuery>response.data.plansBySpace;
  }
  async GetDomain(id: string): Promise<GetDomainQuery> {
    const statement = `query GetDomain($id: ID!) {
        getDomain(id: $id) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetDomainQuery>response.data.getDomain;
  }
  async ListDomains(
    filter?: ModelDomainFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListDomainsQuery> {
    const statement = `query ListDomains($filter: ModelDomainFilterInput, $limit: Int, $nextToken: String) {
        listDomains(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListDomainsQuery>response.data.listDomains;
  }
  async GetComment(id: string): Promise<GetCommentQuery> {
    const statement = `query GetComment($id: ID!) {
        getComment(id: $id) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCommentQuery>response.data.getComment;
  }
  async ListComments(
    filter?: ModelCommentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListCommentsQuery> {
    const statement = `query ListComments($filter: ModelCommentFilterInput, $limit: Int, $nextToken: String) {
        listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListCommentsQuery>response.data.listComments;
  }
  async CommentsBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCommentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<CommentsBySpaceQuery> {
    const statement = `query CommentsBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelCommentFilterInput, $limit: Int, $nextToken: String) {
        commentsBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CommentsBySpaceQuery>response.data.commentsBySpace;
  }
  async CommentsByFeature(
    featureID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCommentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<CommentsByFeatureQuery> {
    const statement = `query CommentsByFeature($featureID: ID!, $sortDirection: ModelSortDirection, $filter: ModelCommentFilterInput, $limit: Int, $nextToken: String) {
        commentsByFeature(featureID: $featureID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      featureID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CommentsByFeatureQuery>response.data.commentsByFeature;
  }
  async GetFeature(id: string): Promise<GetFeatureQuery> {
    const statement = `query GetFeature($id: ID!) {
        getFeature(id: $id) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFeatureQuery>response.data.getFeature;
  }
  async ListFeatures(
    filter?: ModelFeatureFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFeaturesQuery> {
    const statement = `query ListFeatures($filter: ModelFeatureFilterInput, $limit: Int, $nextToken: String) {
        listFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFeaturesQuery>response.data.listFeatures;
  }
  async FeaturesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFeatureFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<FeaturesBySpaceQuery> {
    const statement = `query FeaturesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelFeatureFilterInput, $limit: Int, $nextToken: String) {
        featuresBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <FeaturesBySpaceQuery>response.data.featuresBySpace;
  }
  async FeaturesByDomain(
    domainID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFeatureFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<FeaturesByDomainQuery> {
    const statement = `query FeaturesByDomain($domainID: ID!, $sortDirection: ModelSortDirection, $filter: ModelFeatureFilterInput, $limit: Int, $nextToken: String) {
        featuresByDomain(domainID: $domainID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      domainID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <FeaturesByDomainQuery>response.data.featuresByDomain;
  }
  async GetHashtag(id: string): Promise<GetHashtagQuery> {
    const statement = `query GetHashtag($id: ID!) {
        getHashtag(id: $id) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetHashtagQuery>response.data.getHashtag;
  }
  async ListHashtags(
    filter?: ModelHashtagFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListHashtagsQuery> {
    const statement = `query ListHashtags($filter: ModelHashtagFilterInput, $limit: Int, $nextToken: String) {
        listHashtags(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListHashtagsQuery>response.data.listHashtags;
  }
  async HashtagsBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelHashtagFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<HashtagsBySpaceQuery> {
    const statement = `query HashtagsBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelHashtagFilterInput, $limit: Int, $nextToken: String) {
        hashtagsBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <HashtagsBySpaceQuery>response.data.hashtagsBySpace;
  }
  async GetProfile(id: string): Promise<GetProfileQuery> {
    const statement = `query GetProfile($id: ID!) {
        getProfile(id: $id) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetProfileQuery>response.data.getProfile;
  }
  async ListProfiles(
    filter?: ModelProfileFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListProfilesQuery> {
    const statement = `query ListProfiles($filter: ModelProfileFilterInput, $limit: Int, $nextToken: String) {
        listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListProfilesQuery>response.data.listProfiles;
  }
  async ProfilesByUserID(
    userID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelProfileFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ProfilesByUserIDQuery> {
    const statement = `query ProfilesByUserID($userID: String!, $sortDirection: ModelSortDirection, $filter: ModelProfileFilterInput, $limit: Int, $nextToken: String) {
        profilesByUserID(userID: $userID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ProfilesByUserIDQuery>response.data.profilesByUserID;
  }
  async GetOrganisation(id: string): Promise<GetOrganisationQuery> {
    const statement = `query GetOrganisation($id: ID!) {
        getOrganisation(id: $id) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetOrganisationQuery>response.data.getOrganisation;
  }
  async ListOrganisations(
    filter?: ModelOrganisationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListOrganisationsQuery> {
    const statement = `query ListOrganisations($filter: ModelOrganisationFilterInput, $limit: Int, $nextToken: String) {
        listOrganisations(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListOrganisationsQuery>response.data.listOrganisations;
  }
  async OrganisationsByToken(
    shareToken: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelOrganisationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<OrganisationsByTokenQuery> {
    const statement = `query OrganisationsByToken($shareToken: String!, $sortDirection: ModelSortDirection, $filter: ModelOrganisationFilterInput, $limit: Int, $nextToken: String) {
        organisationsByToken(shareToken: $shareToken, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      shareToken
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <OrganisationsByTokenQuery>response.data.organisationsByToken;
  }
  async OrganisationsByStripeAccount(
    connectedAccountStripeID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelOrganisationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<OrganisationsByStripeAccountQuery> {
    const statement = `query OrganisationsByStripeAccount($connectedAccountStripeID: String!, $sortDirection: ModelSortDirection, $filter: ModelOrganisationFilterInput, $limit: Int, $nextToken: String) {
        organisationsByStripeAccount(connectedAccountStripeID: $connectedAccountStripeID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      connectedAccountStripeID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <OrganisationsByStripeAccountQuery>(
      response.data.organisationsByStripeAccount
    );
  }
  async GetProperty(id: string): Promise<GetPropertyQuery> {
    const statement = `query GetProperty($id: ID!) {
        getProperty(id: $id) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPropertyQuery>response.data.getProperty;
  }
  async ListProperties(
    filter?: ModelPropertyFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPropertiesQuery> {
    const statement = `query ListProperties($filter: ModelPropertyFilterInput, $limit: Int, $nextToken: String) {
        listProperties(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPropertiesQuery>response.data.listProperties;
  }
  async PropertiesByOrganisation(
    organisationID: string,
    id?: ModelIDKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelPropertyFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PropertiesByOrganisationQuery> {
    const statement = `query PropertiesByOrganisation($organisationID: ID!, $id: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelPropertyFilterInput, $limit: Int, $nextToken: String) {
        propertiesByOrganisation(organisationID: $organisationID, id: $id, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      organisationID
    };
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PropertiesByOrganisationQuery>(
      response.data.propertiesByOrganisation
    );
  }
  async PropertiesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPropertyFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PropertiesBySpaceQuery> {
    const statement = `query PropertiesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPropertyFilterInput, $limit: Int, $nextToken: String) {
        propertiesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PropertiesBySpaceQuery>response.data.propertiesBySpace;
  }
  async GetMission(id: string): Promise<GetMissionQuery> {
    const statement = `query GetMission($id: ID!) {
        getMission(id: $id) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetMissionQuery>response.data.getMission;
  }
  async ListMissions(
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListMissionsQuery> {
    const statement = `query ListMissions($filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        listMissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListMissionsQuery>response.data.listMissions;
  }
  async MissionsByOrderedOrganisation(
    orderedOrganisationID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByOrderedOrganisationQuery> {
    const statement = `query MissionsByOrderedOrganisation($orderedOrganisationID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByOrderedOrganisation(orderedOrganisationID: $orderedOrganisationID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      orderedOrganisationID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByOrderedOrganisationQuery>(
      response.data.missionsByOrderedOrganisation
    );
  }
  async MissionsByOrderedOrganisationBySpace(
    orderedOrganisationID: string,
    spaceID?: ModelIDKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByOrderedOrganisationBySpaceQuery> {
    const statement = `query MissionsByOrderedOrganisationBySpace($orderedOrganisationID: ID!, $spaceID: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByOrderedOrganisationBySpace(orderedOrganisationID: $orderedOrganisationID, spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      orderedOrganisationID
    };
    if (spaceID) {
      gqlAPIServiceArguments.spaceID = spaceID;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByOrderedOrganisationBySpaceQuery>(
      response.data.missionsByOrderedOrganisationBySpace
    );
  }
  async MissionsByOrganisation(
    organisationID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByOrganisationQuery> {
    const statement = `query MissionsByOrganisation($organisationID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByOrganisation(organisationID: $organisationID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      organisationID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByOrganisationQuery>response.data.missionsByOrganisation;
  }
  async MissionsByUser(
    userID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByUserQuery> {
    const statement = `query MissionsByUser($userID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByUser(userID: $userID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByUserQuery>response.data.missionsByUser;
  }
  async MissionsBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsBySpaceQuery> {
    const statement = `query MissionsBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsBySpaceQuery>response.data.missionsBySpace;
  }
  async MissionsBySpaceByRole(
    spaceID: string,
    role?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsBySpaceByRoleQuery> {
    const statement = `query MissionsBySpaceByRole($spaceID: ID!, $role: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsBySpaceByRole(spaceID: $spaceID, role: $role, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (role) {
      gqlAPIServiceArguments.role = role;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsBySpaceByRoleQuery>response.data.missionsBySpaceByRole;
  }
  async MissionsByZoneByRole(
    zoneID: string,
    role?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByZoneByRoleQuery> {
    const statement = `query MissionsByZoneByRole($zoneID: ID!, $role: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByZoneByRole(zoneID: $zoneID, role: $role, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      zoneID
    };
    if (role) {
      gqlAPIServiceArguments.role = role;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByZoneByRoleQuery>response.data.missionsByZoneByRole;
  }
  async MissionsByZone(
    zoneID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByZoneQuery> {
    const statement = `query MissionsByZone($zoneID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByZone(zoneID: $zoneID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      zoneID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByZoneQuery>response.data.missionsByZone;
  }
  async MissionsByTemplate(
    templateMissionID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByTemplateQuery> {
    const statement = `query MissionsByTemplate($templateMissionID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByTemplate(templateMissionID: $templateMissionID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      templateMissionID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByTemplateQuery>response.data.missionsByTemplate;
  }
  async GetVisitTemplate(id: string): Promise<GetVisitTemplateQuery> {
    const statement = `query GetVisitTemplate($id: ID!) {
        getVisitTemplate(id: $id) {
          __typename
          id
          title
          level
          description
          metadata
          deletedAt
          startDateTime
          endDateTime
          hashtags
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          userMissions {
            __typename
            items {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            nextToken
          }
          locale
          realStartedAt
          realEndedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetVisitTemplateQuery>response.data.getVisitTemplate;
  }
  async ListVisitTemplates(
    filter?: ModelVisitTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListVisitTemplatesQuery> {
    const statement = `query ListVisitTemplates($filter: ModelVisitTemplateFilterInput, $limit: Int, $nextToken: String) {
        listVisitTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListVisitTemplatesQuery>response.data.listVisitTemplates;
  }
  async TemplatesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelVisitTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<TemplatesBySpaceQuery> {
    const statement = `query TemplatesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelVisitTemplateFilterInput, $limit: Int, $nextToken: String) {
        templatesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <TemplatesBySpaceQuery>response.data.templatesBySpace;
  }
  async TemplatesByZone(
    zoneID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelVisitTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<TemplatesByZoneQuery> {
    const statement = `query TemplatesByZone($zoneID: ID!, $sortDirection: ModelSortDirection, $filter: ModelVisitTemplateFilterInput, $limit: Int, $nextToken: String) {
        templatesByZone(zoneID: $zoneID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      zoneID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <TemplatesByZoneQuery>response.data.templatesByZone;
  }
  async GetCapture(id: string): Promise<GetCaptureQuery> {
    const statement = `query GetCapture($id: ID!) {
        getCapture(id: $id) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCaptureQuery>response.data.getCapture;
  }
  async ListCaptures(
    filter?: ModelCaptureFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListCapturesQuery> {
    const statement = `query ListCaptures($filter: ModelCaptureFilterInput, $limit: Int, $nextToken: String) {
        listCaptures(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListCapturesQuery>response.data.listCaptures;
  }
  async CapturesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCaptureFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<CapturesBySpaceQuery> {
    const statement = `query CapturesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelCaptureFilterInput, $limit: Int, $nextToken: String) {
        capturesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CapturesBySpaceQuery>response.data.capturesBySpace;
  }
  async GetNode(id: string): Promise<GetNodeQuery> {
    const statement = `query GetNode($id: ID!) {
        getNode(id: $id) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNodeQuery>response.data.getNode;
  }
  async ListNodes(
    filter?: ModelNodeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNodesQuery> {
    const statement = `query ListNodes($filter: ModelNodeFilterInput, $limit: Int, $nextToken: String) {
        listNodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNodesQuery>response.data.listNodes;
  }
  async NodesByCapture(
    captureID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelNodeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<NodesByCaptureQuery> {
    const statement = `query NodesByCapture($captureID: ID!, $sortDirection: ModelSortDirection, $filter: ModelNodeFilterInput, $limit: Int, $nextToken: String) {
        nodesByCapture(captureID: $captureID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      captureID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <NodesByCaptureQuery>response.data.nodesByCapture;
  }
  OnCreateMissionListener(
    spaceID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateMission">>
  > {
    const statement = `subscription OnCreateMission($spaceID: ID) {
        onCreateMission(spaceID: $spaceID) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (spaceID) {
      gqlAPIServiceArguments.spaceID = spaceID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateMission">>
    >;
  }

  OnUpdateMissionListener(
    id?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateMission">>
  > {
    const statement = `subscription OnUpdateMission($id: ID) {
        onUpdateMission(id: $id) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateMission">>
    >;
  }

  OnDeleteMissionListener(
    id?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteMission">>
  > {
    const statement = `subscription OnDeleteMission($id: ID) {
        onDeleteMission(id: $id) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          domains
          templateMissionID
          templateMission {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          locale
          isInWaitingRoom
          blockedInChat
          connectedToLiveAt
          disconnectedFromLiveAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteMission">>
    >;
  }

  OnUpdateVisitTemplateListener(
    id?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateVisitTemplate">>
  > {
    const statement = `subscription OnUpdateVisitTemplate($id: ID) {
        onUpdateVisitTemplate(id: $id) {
          __typename
          id
          title
          level
          description
          metadata
          deletedAt
          startDateTime
          endDateTime
          hashtags
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          userMissions {
            __typename
            items {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            nextToken
          }
          locale
          realStartedAt
          realEndedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateVisitTemplate">
      >
    >;
  }

  SubscribeToChannelListener(
    name: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "subscribeToChannel">>
  > {
    const statement = `subscription SubscribeToChannel($name: String!) {
        subscribeToChannel(name: $name) {
          __typename
          name
          data
        }
      }`;
    const gqlAPIServiceArguments: any = {
      name
    };
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "subscribeToChannel">>
    >;
  }

  OnCreateChatMessageListener(
    filter?: ModelSubscriptionChatMessageFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateChatMessage">>
  > {
    const statement = `subscription OnCreateChatMessage($filter: ModelSubscriptionChatMessageFilterInput) {
        onCreateChatMessage(filter: $filter) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateChatMessage">>
    >;
  }

  OnUpdateChatMessageListener(
    filter?: ModelSubscriptionChatMessageFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateChatMessage">>
  > {
    const statement = `subscription OnUpdateChatMessage($filter: ModelSubscriptionChatMessageFilterInput) {
        onUpdateChatMessage(filter: $filter) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateChatMessage">>
    >;
  }

  OnDeleteChatMessageListener(
    filter?: ModelSubscriptionChatMessageFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteChatMessage">>
  > {
    const statement = `subscription OnDeleteChatMessage($filter: ModelSubscriptionChatMessageFilterInput) {
        onDeleteChatMessage(filter: $filter) {
          __typename
          id
          message
          type
          visitTemplateID
          visitTemplate {
            __typename
            id
            title
            level
            description
            metadata
            deletedAt
            startDateTime
            endDateTime
            hashtags
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            userMissions {
              __typename
              items {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              nextToken
            }
            locale
            realStartedAt
            realEndedAt
            createdAt
            updatedAt
          }
          authorID
          author {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          timestamp
          receiver
          toAll
          zoomChatRecord {
            __typename
            id
            message
            sender {
              __typename
              name
              userId
            }
            receiver {
              __typename
              name
              userId
            }
            timestamp
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteChatMessage">>
    >;
  }

  OnCreateSpaceListener(
    filter?: ModelSubscriptionSpaceFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSpace">>
  > {
    const statement = `subscription OnCreateSpace($filter: ModelSubscriptionSpaceFilterInput) {
        onCreateSpace(filter: $filter) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSpace">>
    >;
  }

  OnUpdateSpaceListener(
    filter?: ModelSubscriptionSpaceFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSpace">>
  > {
    const statement = `subscription OnUpdateSpace($filter: ModelSubscriptionSpaceFilterInput) {
        onUpdateSpace(filter: $filter) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSpace">>
    >;
  }

  OnDeleteSpaceListener(
    filter?: ModelSubscriptionSpaceFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSpace">>
  > {
    const statement = `subscription OnDeleteSpace($filter: ModelSubscriptionSpaceFilterInput) {
        onDeleteSpace(filter: $filter) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          constructionYear
          classEnergyConsumption
          classGes
          status
          guestLink
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          attachments {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSpace">>
    >;
  }

  OnCreateZoneListener(
    filter?: ModelSubscriptionZoneFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateZone">>
  > {
    const statement = `subscription OnCreateZone($filter: ModelSubscriptionZoneFilterInput) {
        onCreateZone(filter: $filter) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateZone">>
    >;
  }

  OnUpdateZoneListener(
    filter?: ModelSubscriptionZoneFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateZone">>
  > {
    const statement = `subscription OnUpdateZone($filter: ModelSubscriptionZoneFilterInput) {
        onUpdateZone(filter: $filter) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateZone">>
    >;
  }

  OnDeleteZoneListener(
    filter?: ModelSubscriptionZoneFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteZone">>
  > {
    const statement = `subscription OnDeleteZone($filter: ModelSubscriptionZoneFilterInput) {
        onDeleteZone(filter: $filter) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          audioID
          audio {
            __typename
            id
            title
            description
            annexe
            metadata
            ownerID
            owner {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            type
            dimensions
            featureID
            feature {
              __typename
              id
              title
              description
              shortDescription
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              ownerMissionID
              ownerMission {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              level
              comments {
                __typename
                nextToken
              }
              index
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              type
              archivedForMissionID
              stripeProductID
              stripePriceID
              bookingPriceMetadata
              pois {
                __typename
                nextToken
              }
              hashtags
              locale
              createdAt
              updatedAt
            }
            isCoverImage
            index
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            shownInTag
            externalLink
            createdAt
            updatedAt
          }
          startSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteZone">>
    >;
  }

  OnCreateLayerListener(
    filter?: ModelSubscriptionLayerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateLayer">>
  > {
    const statement = `subscription OnCreateLayer($filter: ModelSubscriptionLayerFilterInput) {
        onCreateLayer(filter: $filter) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateLayer">>
    >;
  }

  OnUpdateLayerListener(
    filter?: ModelSubscriptionLayerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateLayer">>
  > {
    const statement = `subscription OnUpdateLayer($filter: ModelSubscriptionLayerFilterInput) {
        onUpdateLayer(filter: $filter) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateLayer">>
    >;
  }

  OnDeleteLayerListener(
    filter?: ModelSubscriptionLayerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteLayer">>
  > {
    const statement = `subscription OnDeleteLayer($filter: ModelSubscriptionLayerFilterInput) {
        onDeleteLayer(filter: $filter) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteLayer">>
    >;
  }

  OnCreateNavigationListener(
    filter?: ModelSubscriptionNavigationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNavigation">>
  > {
    const statement = `subscription OnCreateNavigation($filter: ModelSubscriptionNavigationFilterInput) {
        onCreateNavigation(filter: $filter) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNavigation">>
    >;
  }

  OnUpdateNavigationListener(
    filter?: ModelSubscriptionNavigationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNavigation">>
  > {
    const statement = `subscription OnUpdateNavigation($filter: ModelSubscriptionNavigationFilterInput) {
        onUpdateNavigation(filter: $filter) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNavigation">>
    >;
  }

  OnDeleteNavigationListener(
    filter?: ModelSubscriptionNavigationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNavigation">>
  > {
    const statement = `subscription OnDeleteNavigation($filter: ModelSubscriptionNavigationFilterInput) {
        onDeleteNavigation(filter: $filter) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNavigation">>
    >;
  }

  OnCreatePOIListener(
    filter?: ModelSubscriptionPOIFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePOI">>
  > {
    const statement = `subscription OnCreatePOI($filter: ModelSubscriptionPOIFilterInput) {
        onCreatePOI(filter: $filter) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePOI">>
    >;
  }

  OnUpdatePOIListener(
    filter?: ModelSubscriptionPOIFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePOI">>
  > {
    const statement = `subscription OnUpdatePOI($filter: ModelSubscriptionPOIFilterInput) {
        onUpdatePOI(filter: $filter) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePOI">>
    >;
  }

  OnDeletePOIListener(
    filter?: ModelSubscriptionPOIFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePOI">>
  > {
    const statement = `subscription OnDeletePOI($filter: ModelSubscriptionPOIFilterInput) {
        onDeletePOI(filter: $filter) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePOI">>
    >;
  }

  OnCreatePlanListener(
    filter?: ModelSubscriptionPlanFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePlan">>
  > {
    const statement = `subscription OnCreatePlan($filter: ModelSubscriptionPlanFilterInput) {
        onCreatePlan(filter: $filter) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePlan">>
    >;
  }

  OnUpdatePlanListener(
    filter?: ModelSubscriptionPlanFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePlan">>
  > {
    const statement = `subscription OnUpdatePlan($filter: ModelSubscriptionPlanFilterInput) {
        onUpdatePlan(filter: $filter) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePlan">>
    >;
  }

  OnDeletePlanListener(
    filter?: ModelSubscriptionPlanFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePlan">>
  > {
    const statement = `subscription OnDeletePlan($filter: ModelSubscriptionPlanFilterInput) {
        onDeletePlan(filter: $filter) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePlan">>
    >;
  }

  OnCreateDomainListener(
    filter?: ModelSubscriptionDomainFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateDomain">>
  > {
    const statement = `subscription OnCreateDomain($filter: ModelSubscriptionDomainFilterInput) {
        onCreateDomain(filter: $filter) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateDomain">>
    >;
  }

  OnUpdateDomainListener(
    filter?: ModelSubscriptionDomainFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateDomain">>
  > {
    const statement = `subscription OnUpdateDomain($filter: ModelSubscriptionDomainFilterInput) {
        onUpdateDomain(filter: $filter) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateDomain">>
    >;
  }

  OnDeleteDomainListener(
    filter?: ModelSubscriptionDomainFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteDomain">>
  > {
    const statement = `subscription OnDeleteDomain($filter: ModelSubscriptionDomainFilterInput) {
        onDeleteDomain(filter: $filter) {
          __typename
          id
          name
          slug
          abbreviation
          description
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          parentID
          parent {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          children {
            __typename
            items {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            nextToken
          }
          type
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteDomain">>
    >;
  }

  OnCreateCommentListener(
    filter?: ModelSubscriptionCommentFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateComment">>
  > {
    const statement = `subscription OnCreateComment($filter: ModelSubscriptionCommentFilterInput) {
        onCreateComment(filter: $filter) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateComment">>
    >;
  }

  OnUpdateCommentListener(
    filter?: ModelSubscriptionCommentFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateComment">>
  > {
    const statement = `subscription OnUpdateComment($filter: ModelSubscriptionCommentFilterInput) {
        onUpdateComment(filter: $filter) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateComment">>
    >;
  }

  OnDeleteCommentListener(
    filter?: ModelSubscriptionCommentFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteComment">>
  > {
    const statement = `subscription OnDeleteComment($filter: ModelSubscriptionCommentFilterInput) {
        onDeleteComment(filter: $filter) {
          __typename
          id
          title
          description
          annexe
          metadata
          ownerID
          owner {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          type
          dimensions
          featureID
          feature {
            __typename
            id
            title
            description
            shortDescription
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            ownerMissionID
            ownerMission {
              __typename
              id
              level
              role
              emailStatus
              description
              metadata
              groups
              deletedAt
              startDateTime
              endDateTime
              hashtags
              orderedOrganisationID
              orderedOrganisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              userID
              user {
                __typename
                id
                userID
                avatar
                token
                tokenExpiredAt
                status
                metadata
                deletedAt
                lastConnectedAt
                pseudo
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              domains
              templateMissionID
              templateMission {
                __typename
                id
                title
                level
                description
                metadata
                deletedAt
                startDateTime
                endDateTime
                hashtags
                organisationID
                spaceID
                zoneID
                locale
                realStartedAt
                realEndedAt
                createdAt
                updatedAt
              }
              locale
              isInWaitingRoom
              blockedInChat
              connectedToLiveAt
              disconnectedFromLiveAt
              createdAt
              updatedAt
            }
            level
            comments {
              __typename
              items {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              nextToken
            }
            index
            domainID
            domain {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            type
            archivedForMissionID
            stripeProductID
            stripePriceID
            bookingPriceMetadata
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                domainID
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            hashtags
            locale
            createdAt
            updatedAt
          }
          isCoverImage
          index
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          shownInTag
          externalLink
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteComment">>
    >;
  }

  OnCreateFeatureListener(
    filter?: ModelSubscriptionFeatureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFeature">>
  > {
    const statement = `subscription OnCreateFeature($filter: ModelSubscriptionFeatureFilterInput) {
        onCreateFeature(filter: $filter) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateFeature">>
    >;
  }

  OnUpdateFeatureListener(
    filter?: ModelSubscriptionFeatureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFeature">>
  > {
    const statement = `subscription OnUpdateFeature($filter: ModelSubscriptionFeatureFilterInput) {
        onUpdateFeature(filter: $filter) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateFeature">>
    >;
  }

  OnDeleteFeatureListener(
    filter?: ModelSubscriptionFeatureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteFeature">>
  > {
    const statement = `subscription OnDeleteFeature($filter: ModelSubscriptionFeatureFilterInput) {
        onDeleteFeature(filter: $filter) {
          __typename
          id
          title
          description
          shortDescription
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          ownerMissionID
          ownerMission {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            domains
            templateMissionID
            templateMission {
              __typename
              id
              title
              level
              description
              metadata
              deletedAt
              startDateTime
              endDateTime
              hashtags
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              userMissions {
                __typename
                nextToken
              }
              locale
              realStartedAt
              realEndedAt
              createdAt
              updatedAt
            }
            locale
            isInWaitingRoom
            blockedInChat
            connectedToLiveAt
            disconnectedFromLiveAt
            createdAt
            updatedAt
          }
          level
          comments {
            __typename
            items {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            nextToken
          }
          index
          domainID
          domain {
            __typename
            id
            name
            slug
            abbreviation
            description
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            parentID
            parent {
              __typename
              id
              name
              slug
              abbreviation
              description
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              parentID
              parent {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              children {
                __typename
                nextToken
              }
              type
              createdAt
              updatedAt
            }
            children {
              __typename
              items {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              nextToken
            }
            type
            createdAt
            updatedAt
          }
          type
          archivedForMissionID
          stripeProductID
          stripePriceID
          bookingPriceMetadata
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              domainID
              domain {
                __typename
                id
                name
                slug
                abbreviation
                description
                organisationID
                parentID
                type
                createdAt
                updatedAt
              }
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          hashtags
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteFeature">>
    >;
  }

  OnCreateHashtagListener(
    filter?: ModelSubscriptionHashtagFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateHashtag">>
  > {
    const statement = `subscription OnCreateHashtag($filter: ModelSubscriptionHashtagFilterInput) {
        onCreateHashtag(filter: $filter) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateHashtag">>
    >;
  }

  OnUpdateHashtagListener(
    filter?: ModelSubscriptionHashtagFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateHashtag">>
  > {
    const statement = `subscription OnUpdateHashtag($filter: ModelSubscriptionHashtagFilterInput) {
        onUpdateHashtag(filter: $filter) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateHashtag">>
    >;
  }

  OnDeleteHashtagListener(
    filter?: ModelSubscriptionHashtagFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteHashtag">>
  > {
    const statement = `subscription OnDeleteHashtag($filter: ModelSubscriptionHashtagFilterInput) {
        onDeleteHashtag(filter: $filter) {
          __typename
          id
          name
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteHashtag">>
    >;
  }

  OnCreateProfileListener(
    filter?: ModelSubscriptionProfileFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateProfile">>
  > {
    const statement = `subscription OnCreateProfile($filter: ModelSubscriptionProfileFilterInput) {
        onCreateProfile(filter: $filter) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateProfile">>
    >;
  }

  OnUpdateProfileListener(
    filter?: ModelSubscriptionProfileFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateProfile">>
  > {
    const statement = `subscription OnUpdateProfile($filter: ModelSubscriptionProfileFilterInput) {
        onUpdateProfile(filter: $filter) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateProfile">>
    >;
  }

  OnDeleteProfileListener(
    filter?: ModelSubscriptionProfileFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteProfile">>
  > {
    const statement = `subscription OnDeleteProfile($filter: ModelSubscriptionProfileFilterInput) {
        onDeleteProfile(filter: $filter) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteProfile">>
    >;
  }

  OnCreateOrganisationListener(
    filter?: ModelSubscriptionOrganisationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateOrganisation">>
  > {
    const statement = `subscription OnCreateOrganisation($filter: ModelSubscriptionOrganisationFilterInput) {
        onCreateOrganisation(filter: $filter) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateOrganisation">
      >
    >;
  }

  OnUpdateOrganisationListener(
    filter?: ModelSubscriptionOrganisationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateOrganisation">>
  > {
    const statement = `subscription OnUpdateOrganisation($filter: ModelSubscriptionOrganisationFilterInput) {
        onUpdateOrganisation(filter: $filter) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateOrganisation">
      >
    >;
  }

  OnDeleteOrganisationListener(
    filter?: ModelSubscriptionOrganisationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteOrganisation">>
  > {
    const statement = `subscription OnDeleteOrganisation($filter: ModelSubscriptionOrganisationFilterInput) {
        onDeleteOrganisation(filter: $filter) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          properties {
            __typename
            items {
              __typename
              id
              type
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              zoneID
              zone {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          shareToken
          tokenExpiresAt
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeToken
          stripeChargesEnabled
          contactDetails
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteOrganisation">
      >
    >;
  }

  OnCreatePropertyListener(
    filter?: ModelSubscriptionPropertyFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateProperty">>
  > {
    const statement = `subscription OnCreateProperty($filter: ModelSubscriptionPropertyFilterInput) {
        onCreateProperty(filter: $filter) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateProperty">>
    >;
  }

  OnUpdatePropertyListener(
    filter?: ModelSubscriptionPropertyFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateProperty">>
  > {
    const statement = `subscription OnUpdateProperty($filter: ModelSubscriptionPropertyFilterInput) {
        onUpdateProperty(filter: $filter) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateProperty">>
    >;
  }

  OnDeletePropertyListener(
    filter?: ModelSubscriptionPropertyFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteProperty">>
  > {
    const statement = `subscription OnDeleteProperty($filter: ModelSubscriptionPropertyFilterInput) {
        onDeleteProperty(filter: $filter) {
          __typename
          id
          type
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            shareToken
            tokenExpiresAt
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeToken
            stripeChargesEnabled
            contactDetails
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            properties {
              __typename
              items {
                __typename
                id
                type
                deletedAt
                organisationID
                spaceID
                zoneID
                createdAt
                updatedAt
              }
              nextToken
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            constructionYear
            classEnergyConsumption
            classGes
            status
            guestLink
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              properties {
                __typename
                nextToken
              }
              shareToken
              tokenExpiresAt
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeToken
              stripeChargesEnabled
              contactDetails
              createdAt
              updatedAt
            }
            attachments {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                audioID
                startSweepID
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              audioID
              audio {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              startSweepID
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              properties {
                __typename
                nextToken
              }
              zones {
                __typename
                nextToken
              }
              constructionYear
              classEnergyConsumption
              classGes
              status
              guestLink
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              attachments {
                __typename
                id
                title
                description
                annexe
                metadata
                ownerID
                spaceID
                type
                dimensions
                featureID
                isCoverImage
                index
                shownInTag
                externalLink
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                shareToken
                tokenExpiresAt
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeToken
                stripeChargesEnabled
                contactDetails
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            audioID
            audio {
              __typename
              id
              title
              description
              annexe
              metadata
              ownerID
              owner {
                __typename
                id
                level
                role
                emailStatus
                description
                metadata
                groups
                deletedAt
                startDateTime
                endDateTime
                hashtags
                orderedOrganisationID
                organisationID
                userID
                spaceID
                zoneID
                domains
                templateMissionID
                locale
                isInWaitingRoom
                blockedInChat
                connectedToLiveAt
                disconnectedFromLiveAt
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                constructionYear
                classEnergyConsumption
                classGes
                status
                guestLink
                organisationID
                createdAt
                updatedAt
              }
              type
              dimensions
              featureID
              feature {
                __typename
                id
                title
                description
                shortDescription
                spaceID
                ownerMissionID
                level
                index
                domainID
                type
                archivedForMissionID
                stripeProductID
                stripePriceID
                bookingPriceMetadata
                hashtags
                locale
                createdAt
                updatedAt
              }
              isCoverImage
              index
              pois {
                __typename
                nextToken
              }
              shownInTag
              externalLink
              createdAt
              updatedAt
            }
            startSweepID
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteProperty">>
    >;
  }

  OnCreateCaptureListener(
    filter?: ModelSubscriptionCaptureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateCapture">>
  > {
    const statement = `subscription OnCreateCapture($filter: ModelSubscriptionCaptureFilterInput) {
        onCreateCapture(filter: $filter) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateCapture">>
    >;
  }

  OnUpdateCaptureListener(
    filter?: ModelSubscriptionCaptureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateCapture">>
  > {
    const statement = `subscription OnUpdateCapture($filter: ModelSubscriptionCaptureFilterInput) {
        onUpdateCapture(filter: $filter) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateCapture">>
    >;
  }

  OnDeleteCaptureListener(
    filter?: ModelSubscriptionCaptureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteCapture">>
  > {
    const statement = `subscription OnDeleteCapture($filter: ModelSubscriptionCaptureFilterInput) {
        onDeleteCapture(filter: $filter) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteCapture">>
    >;
  }

  OnCreateNodeListener(
    filter?: ModelSubscriptionNodeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNode">>
  > {
    const statement = `subscription OnCreateNode($filter: ModelSubscriptionNodeFilterInput) {
        onCreateNode(filter: $filter) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNode">>
    >;
  }

  OnUpdateNodeListener(
    filter?: ModelSubscriptionNodeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNode">>
  > {
    const statement = `subscription OnUpdateNode($filter: ModelSubscriptionNodeFilterInput) {
        onUpdateNode(filter: $filter) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNode">>
    >;
  }

  OnDeleteNodeListener(
    filter?: ModelSubscriptionNodeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNode">>
  > {
    const statement = `subscription OnDeleteNode($filter: ModelSubscriptionNodeFilterInput) {
        onDeleteNode(filter: $filter) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNode">>
    >;
  }
}
